import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const tr: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "Atıf stili dizini bulunamadı",
    metaTitle: "{label} ile başlayan atıf stilleri",
    metaDescription:
      "{label} ile başlayan {count} Citation Style Language stiline göz atın. Gerçek atıf örnekleri ve ücretsiz bir oluşturucu için herhangi bir stili açın.",
    ogSubtitle: "Özel örnekler ve oluşturucularla {count} stil.",
    ogKind: "A–Z Dizini",
    schemaName: "{label} ile başlayan atıf stilleri",
    schemaDescription:
      "{label} ile başlayan {count} Citation Style Language stilinin alfabetik dizini.",
    breadcrumbStyles: "Atıf stilleri",
    heading: "{label} ile başlayan atıf stilleri",
    intro:
      "CSL kataloğunun bu bölümündeki {count} stilin tamamına göz atın. Her sayfa stilin kendi biçimlendirilmiş örneklerini ve ücretsiz bir atıf oluşturucu içerir.",
    navLabel: "A'dan Z'ye atıf stilleri",
    listHeading: "{label} ile başlayan tüm stiller",
  },
  nav: {
    tools: "Araçlar",
    guides: "Rehberler",
    styles: "Tüm stiller",
    bibliography: "Kaynakçam",
    search: "Ara",
    glossary: "Sözlük",
    home: "Ana sayfa",
    menu: "Menü",
  },

  home: {
    title: "Ücretsiz kaynakça oluşturucu",
    subtitle: "2026 için güncellendi",
    intro:
      "Bir DOI, bağlantı veya BibTeX kaydı yapıştırın ya da kitap arayın; APA, MLA, Chicago, Vancouver, Harvard ve binlerce stilde doğru biçimlendirilmiş kaynak gösterimi alın. Tamamen ücretsizdir; ücretli abonelik veya üyelik gerektirmez.",
    browseAllStyles: "{count} atıf stilinin tümüne göz atın →",
    featuresHeading: "Kaynak göstermek için ihtiyacınız olan her şey",
    featureStyles: "{count} stil",
    featureStylesDetail: "APA, MLA, Chicago ve daha fazlası",
    featureBibliographies: "Birden fazla kaynakça",
    featureBibliographiesDetail: "Projeye göre düzenleyin",
    featureBookSearch: "Kitap arama",
    featureBookSearchDetail: "Başlığa veya yazara göre",
    featureExport: "İstediğiniz yere aktarın",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "Koyu tema",
    featureDarkModeDetail: "Gözü yormaz",
    featureNoSignup: "Üyelik yok",
    featureNoSignupDetail: "Her zaman ücretsiz, ücretli abonelik gerektirmez",
    aboutHeading:
      "Öğrenciler ve araştırmacılar için ücretsiz kaynakça oluşturucu",
    aboutBody:
      "CitationEasy 10.000'den fazla akademik atıf stilini destekler. Psikoloji için APA, edebiyat için MLA, tarih için Chicago ya da tıp dergileri için Vancouver — biçimlendirme, bir yaklaşıklıktan değil, stilin kendi resmî tanımından gelir.",
    howItWorksHeading: "Nasıl çalışır",
    howItWorksStep1:
      "Bir DOI, bağlantı, ISBN, PubMed veya arXiv kimliği ya da BibTeX kaydı yapıştırın; kitabı başlığından da arayabilirsiniz.",
    howItWorksStep2:
      "Atıf stilinizi seçin. {count} stilin tümü arasında aramak için yazmaya başlayın.",
    howItWorksStep3:
      "Hazır kaynağı kopyalayın ya da kaynakçaya kaydedip Word, BibTeX veya RIS olarak dışa aktarın.",
    privacyNote:
      "Kaynakçanız kendi tarayıcınızda saklanır. Hesap gerekmez ve hiçbir şey sunucuya yüklenmez.",
  },

  hubs: {
    toolsTitle: "Ücretsiz yazma ve kaynak gösterme araçları",
    toolsIntro:
      "Tarayıcıda çalışan {count} araç: her kaynak türü için oluşturucular, kelime ve karakter sayaçları, okunabilirlik analizi, biçimlendiriciler ve dönüştürücüler. Hepsi ücretsiz ve anında.",
    stylesTitle: "Tüm atıf stillerine göz atın",
    stylesIntro:
      "Citation Style Language projesindeki {count} stilin tamamı; ülkeye, konuya ve akademik alana göre aranabilir ve filtrelenebilir.",
    guidesTitle: "Kaynak gösterme ve akademik yazım rehberleri",
    guidesIntro:
      "Her kaynak türüne nasıl atıf yapılacağı, bulduklarınızı nasıl değerlendireceğiniz ve daha iyi nasıl yazacağınız üzerine ayrıntılı rehberler.",
    howToCiteTitle: "Herhangi bir kaynağa nasıl atıf yapılır",
    howToCiteIntro:
      "Her yaygın kaynak türünü başlıca atıf stilleriyle eşleştiren, her biri gerçek bir çözümlü örnek içeren adım adım sayfalar.",
    faqTitle: "Kaynak gösterme hakkında sık sorulanlar",
    faqIntro:
      "Öğrencilerin atıf yaparken gerçekten sorduğu sorulara kısa ve doğru yanıtlar.",
    glossaryTitle: "Kaynak gösterme sözlüğü",
    glossaryIntro:
      "Stil kılavuzlarında ve ödev yönergelerinde karşınıza çıkan terimlerin açık tanımları.",
    openHub: "Aç",
  },

  styleLanding: {
    metaTitle: "Ücretsiz {style} kaynakça oluşturucu",
    metaDescription:
      "{style} kaynak gösterimlerini ücretsiz oluşturun. Bir DOI, bağlantı, ISBN veya BibTeX yapıştırın; doğru {style} biçiminde kaynakça girdisini ve metin içi atfı alın.",
    heading: "{style} kaynakça oluşturucu",
    intro:
      "Kitaplar, dergi makaleleri ve web siteleri için doğru {style} kaynak gösterimlerini tek tıkla oluşturun. Ücretsiz ve üyeliksiz.",
    aboutHeading: "{style} hakkında",
    whenToUseHeading: "{style} ne zaman kullanılır",
    factsHeading: "Bir bakışta {style}",
    factEdition: "Baskı",
    factSystem: "Atıf sistemi",
    factInText: "Metin içi biçim",
    factReferenceList: "Liste adı",
    factFields: "Yaygın olduğu alanlar",
    systemAuthorDate: "Yazar–tarih",
    systemNumbered: "Numaralı",
    systemFootnotes: "Dipnot",
    howToHeading: "Bu {style} oluşturucusu nasıl kullanılır",
    howToStep1:
      "Yukarıdaki kutuya bir bağlantı, DOI, ISBN veya BibTeX kaydı yapıştırın ya da kitabı başlığından arayın.",
    howToStep2:
      "{style} bu sayfada zaten seçili, doğrudan oluşturmaya geçebilirsiniz.",
    howToStep3:
      "Sonucu belgenize kopyalayın ya da kaydedip listenin tamamını sonra dışa aktarın.",
    relatedHeading: "Daha fazla {style} kaynağı",
    englishOnlyNote:
      "Ayrıntılı {style} rehberleri ve kaynak türüne göre örnekler İngilizce olarak mevcuttur.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "Atıf stili bulunamadı",
    metaTitle: "{style} kaynakça oluşturucu - ücretsiz {style} biçimi",
    metaFormatAndFields:
      "{style}, {fields} alanlarında kullanılan bir {format} stilidir.",
    metaFormatOnly: "{style}, bir {format} stilidir.",
    metaFieldsOnly: "{style}, {fields} alanlarında kullanılır.",
    metaPromiseNote:
      "Gerçek bir {style} dipnotunu görün, kendi dipnotunuzu ücretsiz oluşturun.",
    metaPromiseExamples:
      "Dergi makalesi, kitap ve web sitesi için gerçek {style} kaynak gösterimi örneklerini görün, kendi kaynağınızı ücretsiz oluşturun.",
    ogKindFormat: "{format} stili",
    ogKindDefault: "Atıf stili",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "ve",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "{name} için atıf stili. Citation Style Language deposundan alınmıştır.",
    genericWhenUsed:
      "{name} stilini kullanan yayınlara gönderim yaparken veya bu yayınlarda atıf yaparken.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "antropoloji",
    disciplineAstronomy: "astronomi",
    disciplineBiology: "biyoloji",
    disciplineBotany: "botanik",
    disciplineChemistry: "kimya",
    disciplineCommunications: "iletişim",
    disciplineEngineering: "mühendislik",
    disciplineGenericBase: "genel",
    disciplineGeography: "coğrafya",
    disciplineGeology: "jeoloji",
    disciplineHistory: "tarih",
    disciplineHumanities: "beşeri bilimler",
    disciplineLaw: "hukuk",
    disciplineLinguistics: "dilbilim",
    disciplineLiterature: "edebiyat",
    disciplineMath: "matematik",
    disciplineMedicine: "tıp",
    disciplinePhilosophy: "felsefe",
    disciplinePhysics: "fizik",
    disciplinePoliticalScience: "siyaset bilimi",
    disciplinePsychology: "psikoloji",
    disciplineScience: "fen bilimleri",
    disciplineSocialScience: "sosyal bilimler",
    disciplineSociology: "sosyoloji",
    disciplineTheology: "teoloji",
    disciplineZoology: "zooloji",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "yazar–tarih stilidir: metin içi atıflar yazarı ve yayın yılını belirtir, kaynakça ise yazarın soyadına göre alfabetik olarak sıralanır",
    formatClassNumeric:
      "numaralı bir stildir: kaynaklar ilk kez atıfta bulunuldukları sıraya göre numaralanır ve metin içi atıflar bu numaraları kullanır",
    formatClassNote:
      "not tabanlı bir stildir: atıflar metin içinde parantez yerine dipnot veya sonnot olarak yer alır",
    formatClassLabel:
      "etiket tabanlı bir stildir: metin içi atıflar yazar adı ve yıldan oluşan kısa bir etiket kullanır",
    formatClassAuthor:
      "yalnızca yazarı belirten bir stildir: metin içi atıflar yazarı adlandırır, tüm ayrıntılar kaynakçada yer alır",
    formatClassOther: "bir {format} stilidir",
    breadcrumbStyles: "Atıf stilleri",
    internationalLabel: "Uluslararası",
    heading: "{style} kaynakça oluşturucu",
    intro:
      "Kitaplar, makaleler ve web siteleri için doğru {style} kaynak gösterimlerini tek tıkla oluşturun.",
    examplesHeading: "{style} kaynak gösterimi örnekleri",
    examplesIntro: "Aynı üç kaynağın {style} ile biçimlendirilmiş hali:",
    examplesIntroWithFormat:
      "Aynı üç kaynağın {style} ile biçimlendirilmiş hali — {format}:",
    examplesNoteOnlyIntro:
      "{style}, not tabanlı bir stildir: kaynakçası yoktur ve her atıf bir dipnot olarak yer alır. İşte örnek dergi makalemizin {style} ile gösterimi:",
    labelJournalArticle: "Dergi makalesi",
    labelBook: "Kitap",
    labelWebsite: "Web sitesi",
    labelFootnote: "Dipnot (dergi makalesi)",
    labelInText: "Metin içi atıf (dergi makalesi için)",
    aboutHeading: "{style} hakkında",
    whenToUseLabel: "{style} ne zaman kullanılır:",
    commonInLabel: "Yaygın olduğu alanlar:",
    subjectAreasLabel: "Konu alanları:",
    formattingRulesLabel: "Biçimlendirme kuralları:",
    parentStylePrefix: "{style}, temel aldığı",
    parentStyleSuffix: " stilinin biçimlendirmesini izler.",
    howToHeading: "Bu {style} oluşturucusu nasıl kullanılır",
    howToBody:
      'Yukarıdaki kutuya bir DOI, bir haber makalesi veya web sayfası bağlantısı ya da ham BibTeX yapıştırın. Ayrıca bir kitabı başlığından veya yazarından arayıp ISBN ile kaynak gösterebilirsiniz. Stil açılır menüsünden "{style}" seçeneğini belirleyin (bu sayfada zaten seçilidir), ardından "Kaynak oluştur" düğmesine tıklayın. Sonucu kaynak listenize veya kaynakçanıza kopyalayın. Kopyalamadan önce oluşturulan girdiyi düzenleyebilirsiniz (örneğin başlığı düzeltebilir veya bir tarih ekleyebilirsiniz).',
    faqHeading: "{style} hakkında sık sorulan sorular",
    faqWhatIsQ: "{style} nedir?",
    faqWhenQ: "{style} ne zaman kullanılmalıdır?",
    faqInTextQ: "{style} stilinde metin içi atıf nasıl görünür?",
    faqInTextA:
      "{style}, {format}. Örnek dergi makalemize metin içinde şöyle atıfta bulunulur: {example}",
    faqReferenceQ: "{style} stilinde bir kaynakça girdisi nasıl görünür?",
    faqReferenceA:
      "{style} ile biçimlendirilmiş bir dergi makalesi şöyle görünür: {example}",
    faqWhereQ: "{style} yaygın olarak nerede kullanılır?",
    faqWhereA: "{style} {region} kullanılır. {whenUsed}",
    faqRegionDefault: "uluslararası düzeyde",
    faqGenerateQ: "Bir {style} kaynak gösterimini nasıl oluşturabilirim?",
    faqGenerateA:
      "Bu sayfadaki ücretsiz oluşturucuyu kullanın: bir DOI, URL (örneğin bir haber makalesi) veya BibTeX yapıştırın ya da bir kitabı başlığından veya yazarından arayın. Atıf stili olarak {style} seçin, ardından ödevinize veya kaynakçanıza kopyalayabileceğiniz biçimlendirilmiş bir kaynak elde etmek için Oluştur düğmesine tıklayın.",
    footerSupports:
      "dünyanın dört bir yanından birçok atıf stilini destekler. Oluşturucumuz, Citation Style Language (CSL) kaynağını kullanır:",
    footerRepoLink: "resmî CSL deposu",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "Bu atfı oluşturun",
    generateBody:
      "{source} için hazır bir {style} atfı almak üzere bir URL, DOI, ISBN veya kaynak bilgilerini yapıştırın.",
    generateCta: "{tool} aracını açın →",
    guideHeading: "Daha fazlasını öğrenin",
    guideCta: "Rehberin tamamını okuyun: {guide}",
    howToCiteHeading: "{source} kaynağı her stilde nasıl gösterilir",
    howToCiteBody:
      "En sık istenen stiller için biçim kuralları, şablonlar ve çözümlü örnekler.",
    howToCiteMore: "Tüm kaynak türleri ve stiller →",
    citeNowHeading: "{source} için {style} atfını şimdi yapın",
    citeNowHowTo: "Biçim kuralları ve çözümlü örnekler",
    citeNowTool: "{tool} ile oluşturun",
    citeNowHub: "{style} atıf oluşturucu",
    hubSourcesHeading: "{style} stilinde yaygın kaynaklara nasıl atıf yapılır",
    hubGuidesHeading: "{style} rehberleri",
    hubCompareHeading: "{style} stilini diğer stillerle karşılaştırın",
    moreInCollection: "{collection} kategorisinde daha fazlası",
    seeAllInCollection: "{collection} kategorisinin tümünü gör",
  },

  howToCitePage: {
    notFoundTitle: "Bulunamadı",
    title: "{source} kaynağı, {style} stilinde nasıl gösterilir ({edition})",
    metaTitle:
      "{source} kaynağı, {style} stilinde nasıl gösterilir [{edition}, 2026 güncellemesi]",
    metaDescription:
      "{description} için {style} biçiminde ({edition}) nasıl kaynak gösterileceğini öğrenin. Ücretsiz örnekler, şablonlar ve metin içi atıf rehberleri.",
    keywordCite: "{source} {style} kaynak gösterme",
    keywordCitation: "{style} {source} kaynak gösterimi",
    keywordHowTo: "{source} kaynağı nasıl gösterilir",
    keywordExample: "{style} kaynak gösterme örneği",
    keywordReference: "{source} {style} kaynakçası",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "Atıf yapılan eserler",
    refListWorksCitedPage: "atıf yapılan eserler",
    refListBibliography: "Bibliyografya",
    refListBibliographyLower: "bibliyografya",
    refListReferenceList: "Kaynakça",
    refListReferenceListLower: "kaynakça",
    backLink: "← Tüm kaynak gösterme rehberleri",
    lead: "{description} için {style} biçiminde ({edition}) nasıl kaynak gösterileceğini öğrenin. Bu rehber; kaynakça biçimini, metin içi atıf örneklerini ve temel biçimlendirme kurallarını içerir.",
    referenceFormatHeading: "{style} {list} biçimi",
    referenceFormatIntro:
      "{style} stilinde {source} kaynağını {list} bölümünüzde göstermenin standart biçimi şöyledir:",
    noTemplateNote: "Bu kaynak türü için standart {style} şablonunu izleyin.",
    workedHeading: "{source} için {style} örneği",
    workedIntro:
      "İşte {source} için tam bir {style} girdisi; bu sitedeki oluşturucuyu çalıştıran aynı motorla, resmî {style} CSL stil tanımına göre biçimlendirilmiştir:",
    workedNoteOnlyIntro:
      "{style}, {source} kaynağına {list} içinde ayrı bir girdi vermez — yalnızca bir notla kaynak gösterilir. İşte resmî {style} CSL stil tanımına göre biçimlendirilmiş o not:",
    workedOscolaNote:
      "Bu sitede üretilen OSCOLA çıktısı 4. baskının CSL stilini izler; çünkü Citation Style Language deposunda 5. baskının CSL stili henüz yayımlanmadı. Elle düzeltin: her ibid yerine kısa adı ve (n X) yazın, 5. baskının mahkeme tanımlayıcılarını kullanın, bir kanunun kısa biçimini tek tırnak içine alın ve erişim tarihi yerine kalıcı bağlantı veya DOI tercih edin",
    workedCheckedIntro:
      "İşte {source} için tam bir {style} girdisi; elle yazılmış ve bu kaynak için resmî {style} yönergelerine göre denetlenmiştir:",
    workedCheckedNoteOnlyIntro:
      "{style}, {source} kaynağına {list} içinde ayrı bir girdi vermez — yalnızca bir notla kaynak gösterilir. İşte elle yazılmış ve resmî {style} yönergelerine göre denetlenmiş o not:",
    workedInTextLabel: "Buna karşılık gelen metin içi atıf:",
    inTextHeading: "{style} metin içi atfı",
    inTextIntro:
      "Bu kaynağa ödevinizin metni içinde gönderme yaparken şu biçimlerden birini kullanın:",
    inTextParenthetical: "Parantez içi",
    inTextNarrative: "Cümle içi",
    rulesHeading: "Temel {style} biçimlendirme kuralları",
    stepsHeading: "Adım adım rehber",
    step1Label: "Kaynak bilgilerini toplayın:",
    step1Body:
      "Kaynağınız olan {source} için yazar adını, başlığı, yayın tarihini ve URL veya DOI bilgisini toplayın.",
    step2Label: "Kaynakçayı biçimlendirin:",
    step2Body:
      "Öğeleri yukarıda gösterilen {style} ({edition}) şablonuna göre düzenleyin.",
    step3Label: "Metin içi atfı oluşturun:",
    step3Body:
      "Bu kaynağa gönderme yaptığınız yerde ödevinize parantez içi veya cümle içi bir atıf ekleyin.",
    step4Label: "{list} kısmınıza ekleyin:",
    step4Body: "Tam biçimlendirilmiş kaynağı ödevinizin sonuna ekleyin.",
    step5Label: "Biçimlendirmeyi kontrol edin:",
    step5Body:
      "İtalik, noktalama, büyük harf kullanımı ve asılı girintilerin {style} gereklilikleriyle uyumlu olduğunu doğrulayın.",
    ctaHeading: "Bu kaynağı otomatik oluştur",
    ctaBody:
      "Elle biçimlendirmeyi atlayın. Bir DOI, URL veya ISBN’i CitationEasy’ye yapıştırın, saniyeler içinde eksiksiz biçimlendirilmiş bir {style} kaynak gösterimi elde edin.",
    ctaButton: "Şimdi {style} ile kaynak göster →",
    otherStylesHeading: "{source} kaynağı başka stillerde nasıl gösterilir",
    comboLink: "{style} stilinde {source}",
    otherSourcesHeading: "{style} ile başka kaynakları göster",
    resourcesHeading: "Diğer kaynaklar",
    resourceGenerator: "Ücretsiz kaynakça oluşturucu ({count} stil)",
    resourceTools: "Ücretsiz yazma araçları",
    resourceCompare: "Atıf stillerini karşılaştır",
    resourceGuides: "Tüm kaynak gösterme rehberleri",
    resourceCheatSheets: "Özet kılavuzlar (APA, MLA, Chicago)",
    resourceGlossary:
      "Kaynak gösterme sözlüğü (et al., ibid., DOI, asılı girinti)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "Kaynak bilgilerini topla",
    schemaStep1Text:
      "Kaynağınız olan {source} için yazar, başlık, tarih ve URL veya DOI dahil gereken tüm bilgileri toplayın.",
    schemaStep2Name: "{style} ile biçimlendir",
    schemaStep2Text:
      "Kaynak öğelerini doğru sırayla düzenlemek için {style} ({edition}) biçimlendirme kurallarını izleyin.",
    schemaStep3Name: "Metin içi atfı oluştur",
    schemaStep3Text:
      "Ödevinizde {style} biçimini kullanarak buna karşılık gelen bir metin içi atıf ekleyin.",
    schemaStep4Name: "Kaynakçaya ekle",
    schemaStep4Text: "Tam kaynağı ödevinizin sonundaki {list} kısmına ekleyin.",
    faqHowQ: "{style} stilinde {source} kaynağı nasıl gösterilir?",
    faqHowA:
      "{style} ({edition}) stilinde {source} kaynağını göstermek için yazarı, başlığı, tarihi ve kaynağın konumunu belirtin. Otomatik biçimlendirme için ücretsiz kaynakça oluşturucumuzu kullanın.",
    faqFormatQ: "{style} stilinde {source} kaynağının biçimi nedir?",
    faqFormatA:
      "{style} stilinde {source} kaynağının biçimi şöyledir: {example}",
    faqFormatFallback:
      "{style} biçimi; yazar, başlık, tarih ve kaynağın konumu gibi belirli öğelerin belirli bir sırayla düzenlenmesini gerektirir.",
    faqInTextQ:
      "{style} stilinde {source} kaynağının metin içi atfı nasıl görünür?",
    faqInTextA:
      "{style} stilinde, yukarıdaki örneğin metin içi atfı şöyledir: {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Turkish has no articles and no gender. Every form is the bare nominative, so no template
  // attaches a case suffix to it: they carry an invariant head noun ("{source} kaynağı") or a
  // postposition ("{source} için"). Name, Title and Description are capitalised (each opens a
  // heading or sentence); Phrase and Noun are lower-case, except brands and acronyms.
  howToCiteSources: {
    websiteName: "web sitesi",
    websiteTitle: "Web sitesi",
    websitePhrase: "web sitesi",
    websiteNoun: "web sitesi",
    websiteDescription: "Web sayfaları, çevrimiçi makaleler ve web içeriği",

    bookName: "kitap",
    bookTitle: "Kitap",
    bookPhrase: "kitap",
    bookNoun: "kitap",
    bookDescription: "Basılı ve elektronik kitaplar",

    journalArticleName: "dergi makalesi",
    journalArticleTitle: "Dergi makalesi",
    journalArticlePhrase: "dergi makalesi",
    journalArticleNoun: "dergi makalesi",
    journalArticleDescription: "Hakemli ve akademik dergi makaleleri",

    youtubeVideoName: "YouTube videosu",
    youtubeVideoTitle: "YouTube videosu",
    youtubeVideoPhrase: "YouTube videosu",
    youtubeVideoNoun: "YouTube videosu",
    youtubeVideoDescription: "YouTube ve diğer çevrimiçi videolar",

    podcastName: "podcast",
    podcastTitle: "Podcast",
    podcastPhrase: "podcast",
    podcastNoun: "podcast",
    podcastDescription: "Podcast bölümleri ve serileri",

    newspaperArticleName: "gazete makalesi",
    newspaperArticleTitle: "Gazete makalesi",
    newspaperArticlePhrase: "gazete makalesi",
    newspaperArticleNoun: "gazete makalesi",
    newspaperArticleDescription: "Basılı ve çevrimiçi gazete makaleleri",

    magazineArticleName: "magazin makalesi",
    magazineArticleTitle: "Magazin makalesi",
    magazineArticlePhrase: "magazin makalesi",
    magazineArticleNoun: "magazin makalesi",
    magazineArticleDescription: "Basılı ve çevrimiçi magazin makaleleri",

    blogPostName: "blog yazısı",
    blogPostTitle: "Blog yazısı",
    blogPostPhrase: "blog yazısı",
    blogPostNoun: "blog yazısı",
    blogPostDescription: "Blog yazıları ve çevrimiçi görüş yazıları",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "Wikipedia makaleleri ve viki maddeleri",

    pdfName: "PDF belgesi",
    pdfTitle: "PDF belgesi",
    pdfPhrase: "PDF belgesi",
    pdfNoun: "PDF belgesi",
    pdfDescription: "PDF belgeleri ve raporları",

    interviewName: "röportaj",
    interviewTitle: "Röportaj",
    interviewPhrase: "röportaj",
    interviewNoun: "röportaj",
    interviewDescription: "Kişisel, yayımlanmış ve yayın amaçlı röportajlar",

    socialMediaName: "sosyal medya gönderisi",
    socialMediaTitle: "Sosyal medya gönderisi",
    socialMediaPhrase: "sosyal medya gönderisi",
    socialMediaNoun: "sosyal medya gönderisi",
    socialMediaDescription:
      "Tweet’ler ile Instagram, Facebook ve TikTok gönderileri",

    governmentDocumentName: "resmi belge",
    governmentDocumentTitle: "Resmi belge",
    governmentDocumentPhrase: "resmi belge",
    governmentDocumentNoun: "resmi belge",
    governmentDocumentDescription:
      "Resmi raporlar, mevzuat ve kurumsal belgeler",

    dissertationName: "doktora veya yüksek lisans tezi",
    dissertationTitle: "Doktora veya yüksek lisans tezi",
    dissertationPhrase: "doktora veya yüksek lisans tezi",
    dissertationNoun: "doktora veya yüksek lisans tezi",
    dissertationDescription: "Doktora tezleri ve yüksek lisans tezleri",

    conferencePaperName: "konferans bildirisi",
    conferencePaperTitle: "Konferans bildirisi",
    conferencePaperPhrase: "konferans bildirisi",
    conferencePaperNoun: "konferans bildirisi",
    conferencePaperDescription: "Konferans bildirileri ve sunumları",

    lectureNotesName: "ders veya PowerPoint sunumu",
    lectureNotesTitle: "Ders veya PowerPoint sunumu",
    lectureNotesPhrase: "ders veya PowerPoint sunumu",
    lectureNotesNoun: "ders veya PowerPoint sunumu",
    lectureNotesDescription: "Ders anlatımları, slaytlar ve ders materyalleri",

    webinarName: "web semineri",
    webinarTitle: "Web semineri",
    webinarPhrase: "web semineri",
    webinarNoun: "web semineri",
    webinarDescription: "Canlı ve kayıtlı çevrimiçi web seminerleri",

    onlineCourseName: "çevrimiçi kurs",
    onlineCourseTitle: "Çevrimiçi kurs",
    onlineCoursePhrase: "çevrimiçi kurs",
    onlineCourseNoun: "çevrimiçi kurs",
    onlineCourseDescription:
      "Çevrimiçi kurslar ve MOOC’lar (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "PowerPoint sunumu",
    presentationSlidesTitle: "PowerPoint sunumu",
    presentationSlidesPhrase: "PowerPoint sunumu",
    presentationSlidesNoun: "PowerPoint sunumu",
    presentationSlidesDescription: "PowerPoint ve diğer sunum slaytları",

    imageName: "görsel veya fotoğraf",
    imageTitle: "Görsel veya fotoğraf",
    imagePhrase: "görsel veya fotoğraf",
    imageNoun: "görsel veya fotoğraf",
    imageDescription:
      "Fotoğraflar, sanat eserleri, grafikler ve çevrimiçi görseller",

    movieName: "film",
    movieTitle: "Film",
    moviePhrase: "film",
    movieNoun: "film",
    movieDescription: "Film veya sinema filmi",

    documentaryName: "belgesel",
    documentaryTitle: "Belgesel",
    documentaryPhrase: "belgesel",
    documentaryNoun: "belgesel",
    documentaryDescription: "Belgeseller ve kurgusal olmayan filmler",

    tvShowName: "TV programı",
    tvShowTitle: "TV programı",
    tvShowPhrase: "TV programı",
    tvShowNoun: "TV programı",
    tvShowDescription: "TV programı veya dizisi",

    songName: "şarkı veya müzik",
    songTitle: "Şarkı veya müzik",
    songPhrase: "şarkı veya müzik",
    songNoun: "şarkı veya müzik",
    songDescription: "Şarkı veya müzik kaydı",

    poemName: "şiir",
    poemTitle: "Şiir",
    poemPhrase: "şiir",
    poemNoun: "şiir",
    poemDescription:
      "Antolojilerde veya derlemelerde yer alan şiirler ve manzum eserler",

    courtCaseName: "mahkeme davası",
    courtCaseTitle: "Mahkeme davası",
    courtCasePhrase: "mahkeme davası",
    courtCaseNoun: "mahkeme davası",
    courtCaseDescription: "Mahkeme davası veya yargı kararı",

    patentName: "patent",
    patentTitle: "Patent",
    patentPhrase: "patent",
    patentNoun: "patent",
    patentDescription: "Patent veya fikri mülkiyet başvurusu",

    encyclopediaName: "ansiklopedi maddesi",
    encyclopediaTitle: "Ansiklopedi maddesi",
    encyclopediaPhrase: "ansiklopedi maddesi",
    encyclopediaNoun: "ansiklopedi maddesi",
    encyclopediaDescription: "Ansiklopedi makalesi veya maddesi",

    dictionaryName: "sözlük maddesi",
    dictionaryTitle: "Sözlük maddesi",
    dictionaryPhrase: "sözlük maddesi",
    dictionaryNoun: "sözlük maddesi",
    dictionaryDescription: "Sözlük tanımı veya maddesi",

    datasetName: "veri seti",
    datasetTitle: "Veri seti",
    datasetPhrase: "veri seti",
    datasetNoun: "veri seti",
    datasetDescription: "Veri seti veya veri tabanı",

    softwareName: "yazılım veya uygulama",
    softwareTitle: "Yazılım veya uygulama",
    softwarePhrase: "yazılım veya uygulama",
    softwareNoun: "yazılım veya uygulama",
    softwareDescription: "Yazılım, uygulama veya bilgisayar programı",

    videoGameName: "video oyunu",
    videoGameTitle: "Video oyunu",
    videoGamePhrase: "video oyunu",
    videoGameNoun: "video oyunu",
    videoGameDescription: "Video oyunları ve etkileşimli oyun yazılımları",

    pressReleaseName: "basın bülteni",
    pressReleaseTitle: "Basın bülteni",
    pressReleasePhrase: "basın bülteni",
    pressReleaseNoun: "basın bülteni",
    pressReleaseDescription: "Basın bülteni veya haber bülteni",

    reportName: "rapor",
    reportTitle: "Rapor",
    reportPhrase: "rapor",
    reportNoun: "rapor",
    reportDescription: "Rapor veya white paper",

    preprintName: "ön baskı",
    preprintTitle: "Ön baskı",
    preprintPhrase: "ön baskı",
    preprintNoun: "ön baskı",
    preprintDescription:
      "arXiv, bioRxiv ve diğer ön baskı sunucularındaki makaleler",

    bookChapterName: "kitap bölümü",
    bookChapterTitle: "Kitap bölümü",
    bookChapterPhrase: "kitap bölümü",
    bookChapterNoun: "kitap bölümü",
    bookChapterDescription: "Editörlü kitaplardaki bölümler ve denemeler",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT ve diğer üretken yapay zekâ araçları",

    bibleName: "Kutsal Kitap",
    bibleTitle: "Kutsal Kitap",
    biblePhrase: "Kutsal Kitap",
    bibleNoun: "Kutsal Kitap",
    bibleDescription: "Kutsal Kitap, kutsal metinler ve diğer dini metinler",

    tedTalkName: "TED konuşması",
    tedTalkTitle: "TED konuşması",
    tedTalkPhrase: "TED konuşması",
    tedTalkNoun: "TED konuşması",
    tedTalkDescription: "TED konuşmaları ve kayıtlı konferans konuşmaları",

    emailName: "e-posta",
    emailTitle: "E-posta",
    emailPhrase: "e-posta",
    emailNoun: "e-posta",
    emailDescription: "E-postalar, mektuplar ve kişisel yazışmalar",

    redditName: "Reddit veya forum gönderisi",
    redditTitle: "Reddit veya forum gönderisi",
    redditPhrase: "Reddit gönderisi",
    redditNoun: "Reddit gönderisi",
    redditDescription:
      "Reddit konuları, AMA’lar ve çevrimiçi forum veya tartışma panosu gönderileri",

    tweetName: "X (Twitter) gönderisi",
    tweetTitle: "X (Twitter) gönderisi",
    tweetPhrase: "X gönderisi",
    tweetNoun: "X gönderisi",
    tweetDescription:
      "X (eski adıyla Twitter) üzerindeki tweet’ler ve gönderiler",

    mapName: "harita",
    mapTitle: "Harita",
    mapPhrase: "harita",
    mapNoun: "harita",
    mapDescription:
      "Basılı haritalar, atlaslar ve Google Maps gibi dinamik haritalar",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription:
      "Claude sohbetleri ve diğer Anthropic yapay zekâ çıktıları",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription: "Google Gemini sohbetleri ve yapay zekâ çıktıları",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription: "Microsoft Copilot sohbetleri ve yapay zekâ yanıtları",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription:
      "Perplexity yapay zekâ yanıtları, konu dizileri ve bu yanıtların gösterdiği kaynaklar",

    aiImageName: "yapay zekâ ile üretilmiş görsel",
    aiImageTitle: "Yapay zekâ ile üretilmiş görsel",
    aiImagePhrase: "yapay zekâ ile üretilmiş görsel",
    aiImageNoun: "yapay zekâ ile üretilmiş görsel",
    aiImageDescription:
      "DALL·E, Midjourney, Gemini ve diğer yapay zekâ araçlarıyla oluşturulan görseller",

    tiktokName: "TikTok videosu",
    tiktokTitle: "TikTok videosu",
    tiktokPhrase: "TikTok videosu",
    tiktokNoun: "TikTok videosu",
    tiktokDescription: "TikTok videoları ve içerik üreticisi gönderileri",

    instagramName: "Instagram gönderisi",
    instagramTitle: "Instagram gönderisi",
    instagramPhrase: "Instagram gönderisi",
    instagramNoun: "Instagram gönderisi",
    instagramDescription: "Instagram gönderileri, Reels videoları ve hikâyeler",

    statuteName: "kanun veya yasa",
    statuteTitle: "Kanun veya yasa",
    statutePhrase: "kanun veya yasa",
    statuteNoun: "kanun veya yasa",
    statuteDescription:
      "Yasama organlarının çıkardığı kanunlar, yasalar ve kodifiye mevzuat",

    isoStandardName: "ISO standardı",
    isoStandardTitle: "ISO standardı",
    isoStandardPhrase: "ISO standardı",
    isoStandardNoun: "ISO standardı",
    isoStandardDescription: "ISO, IEC ve diğer yayımlanmış teknik standartlar",

    quranName: "Kur'an-ı Kerim",
    quranTitle: "Kur'an-ı Kerim",
    quranPhrase: "Kur'an-ı Kerim",
    quranNoun: "Kur'an-ı Kerim",
    quranDescription: "Arapça aslı veya çevirisiyle Kur'an-ı Kerim",

    ebookNoPageNumbersName: "sayfa numarası olmayan e-kitap",
    ebookNoPageNumbersTitle: "Sayfa numarası olmayan e-kitap",
    ebookNoPageNumbersPhrase: "sayfa numarası olmayan e-kitap",
    ebookNoPageNumbersNoun: "sayfa numarası olmayan e-kitap",
    ebookNoPageNumbersDescription:
      "Sabit sayfa numarası olmayan Kindle, EPUB ve çevrimiçi e-kitaplar",

    speechName: "konuşma",
    speechTitle: "Konuşma",
    speechPhrase: "konuşma",
    speechNoun: "konuşma",
    speechDescription: "Canlı veya kayıtlı konuşmalar, hitabeler ve vaazlar",

    letterName: "mektup",
    letterTitle: "Mektup",
    letterPhrase: "mektup",
    letterNoun: "mektup",
    letterDescription:
      "Yayımlanmış mektuplar, arşivlerdeki mektuplar ve açık mektuplar",

    secondarySourceName: "ikincil kaynak",
    secondarySourceTitle: "Ikincil kaynak",
    secondarySourcePhrase: "ikincil kaynak",
    secondarySourceNoun: "ikincil kaynak",
    secondarySourceDescription:
      "Başka bir eserde alıntılanmış veya kaynak olarak gösterilmiş bir kaynak",
  },

  // ---------------------------------------------------------------------------
  // NOT YET TRANSLATED. These five sections were copied verbatim from `en.ts` so
  // this file still satisfies `Dictionary`; the page types they cover
  // (`taxonomy`, `compare`, `convert`) are deliberately absent from
  // TRANSLATED_PAGE_TYPES, so nothing publishes them in this language yet. The
  // translation pass replaces the strings and only then adds the types.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "Bulunamadı",
    fieldMetaTitle:
      "{field} alanı için atıf stilleri - en iyi kaynak gösterme biçimleri [2026]",
    fieldMetaDescription:
      "{field} alanında en yaygın kullanılan atıf stillerini keşfedin. {fieldLower} alanındaki ödeviniz, teziniz veya makaleniz için doğru kaynak gösterme biçimini bulun.",
    fieldOgTitle: "{field} alanı için atıf stilleri",
    fieldOgSubtitle: "Yaygın olarak istenen stiller: {styles}.",
    fieldOgKind: "Akademik alana göre",
    fieldKeywordStyle: "{field} alanında atıf stili",
    fieldKeywordReferencing: "{field} alanında kaynak gösterme",
    fieldKeywordBest: "{fieldLower} alanı için en iyi atıf stili",
    fieldKeywordBibliography: "{fieldLower} alanında kaynakça biçimi",
    fieldKeywordDiscipline: "alana göre atıf stilleri",
    fieldBackLink: "← Tüm atıf stilleri",
    fieldHeading: "{field} alanı için atıf stilleri",
    fieldRecommendedHeading: "Önerilen atıf stilleri",
    fieldRecommendedIntro:
      "Aşağıdaki atıf stilleri, {field} alanındaki araştırmalarda, dergilerde ve ders ödevlerinde yaygın olarak kullanılır. Daha fazla bilgi edinmek ve kaynak oluşturmaya başlamak için bir stil seçin.",
    fieldStyleFallback:
      "{field} ve ilgili alanlarda kullanılan bir atıf stili.",
    fieldRelatedHeading: "İlgili alanlar",
    fieldRelatedIntro:
      "İlgili akademik alanlarda kullanılan atıf stillerini keşfedin:",
    fieldCtaHeading: "Tüm atıf stillerini keşfedin",
    fieldCtaBody:
      "CitationEasy, her akademik alanda {count} atıf stilini destekler. İhtiyacınız olan tam biçimi bulmak için tüm koleksiyona göz atın.",
    fieldCtaButton: "Tüm stillere göz atın →",
    fieldFaqWhichQ: "{field} alanında hangi atıf stili kullanılır?",
    fieldFaqWhichA:
      "{field} alanında kullanılan atıf stili; ilgili dergiye, kuruma veya eğitmenin gerekliliklerine göre değişir. Yaygın stiller arasında {styles} bulunur. Gerekli biçim için her zaman ödev yönergelerinizi veya hedef dergiyi kontrol edin.",
    fieldFaqSameQ: "{field} alanındaki tüm dergiler aynı stili mi kullanır?",
    fieldFaqSameA:
      "Hayır, {field} alanındaki dergilerin tümü aynı atıf stilini kullanmaz. Bu alanda bazı stiller daha yaygın olsa da, dergilerin kendine özgü biçimlendirme gereklilikleri olabilir. Makalenizi hazırlamadan önce her zaman derginin yazım kurallarını kontrol edin.",
    fieldFaqChooseQ:
      "{field} alanındaki ödevim için bir atıf stilini nasıl seçerim?",
    fieldFaqChooseA:
      "{field} alanındaki ödeviniz için bir atıf stili seçmek üzere önce eğitmeninizin veya hedef derginin belirli bir stil şart koşup koşmadığını kontrol edin. Koşmuyorsa, yukarıda listelenen {field} alanı için yaygın olarak önerilen stillerden birini kullanın. CitationEasy {count} stilin üzerinde destek sunar ve bunların herhangi birinde kaynak oluşturmayı ücretsiz sağlar.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "Ülke bulunamadı",
    countryMetaTitle:
      "{country} ülkesinde kullanılan atıf stilleri - APA, MLA ve daha fazlası",
    countryMetaDescription:
      "{country} ülkesinde kullanılan atıf stillerine göz atın. {country} ülkesindeki biçimler için ücretsiz kaynakça oluşturucu.",
    countryOgTitle: "{country} ülkesinde kullanılan atıf stilleri",
    countryOgKind: "Ülkeye göre",
    countryHeading: "{country} ülkesinde kullanılan atıf stilleri",
    countryIntroOne:
      "{country} ülkesinde yaygın olarak kullanılan veya bu ülkeyle ilişkilendirilen {count} atıf stili. Özel oluşturucusunu açmak için seçin.",
    countryIntroMany:
      "{country} ülkesinde yaygın olarak kullanılan veya bu ülkeyle ilişkilendirilen {count} atıf stili. Özel bir oluşturucu açmak için birini seçin.",
    countryBrowserTitle: "{country} ülkesinde kullanılan atıf stilleri",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "Konu bulunamadı",
    typeMetaTitle: "{type} konusunda atıf stilleri - ücretsiz oluşturucu",
    typeMetaDescription:
      "{typeLower} konusunda atıf stilleri. APA, MLA, Vancouver ve daha fazlası. Ücretsiz kaynakça oluşturucu.",
    typeOgTitle: "{type} konusunda atıf stilleri",
    typeOgKind: "Konuya göre",
    typeHeading: "{type} konusunda atıf stilleri",
    typeIntroOne:
      "{typeLower} konusunda {count} atıf stili. Sık sorulan sorularla birlikte özel bir oluşturucu açmak için seçin.",
    typeIntroMany:
      "{typeLower} konusunda {count} atıf stili. Sık sorulan sorularla birlikte özel bir oluşturucu açmak için birini seçin.",
    typeBrowserTitle: "{type} konusunda atıf stilleri",

    // ---- Shared chrome ----
    breadcrumbStyles: "Atıf stilleri",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "Atıf stilleri",
    breadcrumbByCountry: "Ülkeye göre",
    breadcrumbByDiscipline: "Alana göre",
    allStylesLink: "← Tüm atıf stilleri",
    internationalLabel: "Uluslararası",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "Psikoloji",
    education: "Eğitim",
    sociology: "Sosyoloji",
    anthropology: "Antropoloji",
    politicalScience: "Siyaset bilimi",
    economics: "Ekonomi",
    business: "İşletme ve yönetim",
    literature: "Edebiyat ve diller",
    history: "Tarih",
    philosophy: "Felsefe",
    law: "Hukuk",
    medicine: "Tıp ve klinik bilimler",
    nursing: "Hemşirelik ve ebelik",
    publicHealth: "Halk sağlığı ve epidemiyoloji",
    pharmacy: "Eczacılık",
    biology: "Biyoloji ve yaşam bilimleri",
    chemistry: "Kimya",
    physics: "Fizik",
    engineering: "Mühendislik",
    computerScience: "Bilgisayar bilimi",
    mathematics: "Matematik ve istatistik",
    environmentalScience: "Çevre bilimi",
    earthScience: "Yer ve jeoloji bilimleri",
    artHistory: "Sanat tarihi ve görsel sanatlar",
    music: "Müzik ve müzikoloji",
    theology: "Teoloji ve din bilimleri",
    socialWork: "Sosyal hizmet",
    linguistics: "Dilbilim",
    architecture: "Mimarlık ve şehir planlama",
    filmMedia: "Sinema ve medya çalışmaları",
    journalism: "Gazetecilik ve iletişim",
    criminology: "Kriminoloji ve ceza adaleti",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "Psikoloji, davranış bilimleri ve bilişsel araştırmalarda yaygın olarak kullanılan atıf stilleri.",
    education:
      "Eğitim araştırmaları, pedagoji ve müfredat çalışmaları için atıf stilleri.",
    sociology:
      "Sosyolojik araştırmalarda ve toplum kuramında kullanılan atıf stilleri.",
    anthropology: "Antropolojik ve etnografik araştırmalar için atıf stilleri.",
    politicalScience:
      "Siyaset bilimi, kamu yönetimi ve kamu politikası araştırmaları için atıf stilleri.",
    economics:
      "Ekonomi ve ekonometri araştırmalarında kullanılan atıf stilleri.",
    business:
      "İşletme, yönetim, pazarlama ve finans araştırmaları için atıf stilleri.",
    literature:
      "Edebiyat araştırmaları, dilbilim ve dil araştırmaları için atıf stilleri.",
    history:
      "Tarih araştırmaları, tarihyazımı ve arşiv çalışmaları için atıf stilleri.",
    philosophy: "Felsefi metinler ve etik araştırmaları için atıf stilleri.",
    law: "Mahkeme belgeleri, hukuk dergileri ve hukuk literatürü için hukuki atıf stilleri.",
    medicine:
      "Tıbbi araştırmalar, klinik çalışmalar ve sağlık hizmetleri için atıf stilleri.",
    nursing:
      "Hemşirelik araştırmaları ve sağlık hizmetleri uygulaması için atıf stilleri.",
    publicHealth:
      "Halk sağlığı araştırmaları ve epidemiyolojik çalışmalar için atıf stilleri.",
    pharmacy: "Eczacılık ve farmakoloji araştırmaları için atıf stilleri.",
    biology: "Biyoloji araştırmaları, ekoloji ve genetik için atıf stilleri.",
    chemistry:
      "Kimya, biyokimya ve malzeme bilimi araştırmaları için atıf stilleri.",
    physics:
      "Fizik, astrofizik ve uygulamalı fizik araştırmaları için atıf stilleri.",
    engineering:
      "Mühendislik ve uygulamalı teknoloji araştırmaları için atıf stilleri.",
    computerScience:
      "Bilgisayar bilimi, yapay zeka ve yazılım mühendisliği araştırmaları için atıf stilleri.",
    mathematics:
      "Matematik, uygulamalı matematik ve istatistik araştırmaları için atıf stilleri.",
    environmentalScience:
      "Çevre araştırmaları ve sürdürülebilirlik çalışmaları için atıf stilleri.",
    earthScience:
      "Jeoloji, jeofizik ve yer bilimleri araştırmaları için atıf stilleri.",
    artHistory:
      "Sanat tarihi, görsel kültür ve müzecilik çalışmaları için atıf stilleri.",
    music:
      "Müzik araştırmaları, kuramı ve icra çalışmaları için atıf stilleri.",
    theology: "Teolojik ve din bilimleri araştırmaları için atıf stilleri.",
    socialWork: "Sosyal hizmet araştırmaları ve uygulaması için atıf stilleri.",
    linguistics: "Dilbilim, fonetik ve dil bilimi için atıf stilleri.",
    architecture:
      "Mimarlık, şehir tasarımı ve planlama araştırmaları için atıf stilleri.",
    filmMedia:
      "Sinema, televizyon, medya ve iletişim çalışmaları için atıf stilleri.",
    journalism:
      "Gazetecilik, medya çalışmaları ve iletişim araştırmaları için atıf stilleri.",
    criminology:
      "Kriminoloji ve ceza adaleti araştırmaları için atıf stilleri.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "Amerika Birleşik Devletleri",
    unitedKingdom: "Birleşik Krallık",
    australia: "Avustralya",
    canada: "Kanada",
    newZealand: "Yeni Zelanda",
    ireland: "İrlanda",
    southAfrica: "Güney Afrika",
    germany: "Almanya",
    france: "Fransa",
    spain: "İspanya",
    italy: "İtalya",
    netherlands: "Hollanda",
    belgium: "Belçika",
    switzerland: "İsviçre",
    austria: "Avusturya",
    portugal: "Portekiz",
    luxembourg: "Lüksemburg",
    sweden: "İsveç",
    norway: "Norveç",
    denmark: "Danimarka",
    finland: "Finlandiya",
    iceland: "İzlanda",
    poland: "Polonya",
    czechRepublic: "Çekya",
    hungary: "Macaristan",
    romania: "Romanya",
    russia: "Rusya",
    ukraine: "Ukrayna",
    greece: "Yunanistan",
    turkey: "Türkiye",
    croatia: "Hırvatistan",
    slovenia: "Slovenya",
    slovakia: "Slovakya",
    serbia: "Sırbistan",
    bulgaria: "Bulgaristan",
    lithuania: "Litvanya",
    latvia: "Letonya",
    estonia: "Estonya",
    japan: "Japonya",
    china: "Çin",
    southKorea: "Güney Kore",
    india: "Hindistan",
    singapore: "Singapur",
    hongKong: "Hong Kong",
    taiwan: "Tayvan",
    malaysia: "Malezya",
    indonesia: "Endonezya",
    thailand: "Tayland",
    vietnam: "Vietnam",
    philippines: "Filipinler",
    pakistan: "Pakistan",
    bangladesh: "Bangladeş",
    sriLanka: "Sri Lanka",
    israel: "İsrail",
    saudiArabia: "Suudi Arabistan",
    unitedArabEmirates: "Birleşik Arap Emirlikleri",
    brazil: "Brezilya",
    mexico: "Meksika",
    argentina: "Arjantin",
    chile: "Şili",
    colombia: "Kolombiya",
    peru: "Peru",
    venezuela: "Venezuela",
    egypt: "Mısır",
    nigeria: "Nijerya",
    kenya: "Kenya",
    morocco: "Fas",
    international: "Uluslararası",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "Tıp",
    nursing: "Hemşirelik",
    publicHealth: "Halk sağlığı",
    pharmacy: "Eczacılık",
    dentistry: "Diş hekimliği",
    veterinary: "Veterinerlik",
    psychology: "Psikoloji",
    sociology: "Sosyoloji",
    anthropology: "Antropoloji",
    politicalScience: "Siyaset bilimi",
    economics: "Ekonomi",
    education: "Eğitim",
    socialWork: "Sosyal hizmet",
    biology: "Biyoloji",
    chemistry: "Kimya",
    physics: "Fizik",
    environmentalScience: "Çevre bilimi",
    earthScience: "Yer bilimleri ve jeoloji",
    agriculture: "Tarım",
    ecology: "Ekoloji",
    engineering: "Mühendislik",
    computerScience: "Bilgisayar bilimi",
    mathematics: "Matematik",
    statistics: "İstatistik",
    history: "Tarih",
    literature: "Edebiyat",
    philosophy: "Felsefe",
    linguistics: "Dilbilim",
    artHistory: "Sanat tarihi",
    music: "Müzik",
    filmMedia: "Sinema ve medya",
    archaeology: "Arkeoloji",
    law: "Hukuk",
    business: "İşletme",
    architecture: "Mimarlık",
    religion: "Din ve teoloji",
    geography: "Coğrafya",
    general: "Genel / disiplinlerarası",
    other: "Diğer",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "Kaynakça",
    listWorksCited: "Atıf yapılan eserler",
    listReferences: "Kaynaklar",
    listBibliography: "Bibliyografya",
    listTableOfAuthorities: "Mevzuat ve içtihat listesi",
    listReferencesCited: "Atıfta bulunulan kaynaklar",
    listLowerReferenceList: "kaynakça",
    listLowerWorksCited: "atıf yapılan eserler",
    listLowerReferences: "kaynaklar",
    listLowerBibliography: "bibliyografya",
    listLowerTableOfAuthorities: "mevzuat ve içtihat listesi",
    listLowerReferencesCited: "atıfta bulunulan kaynaklar",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(Yazar, Yıl)",
    inTextAuthorPage: "(Yazar Sayfa)",
    inTextAuthorYear: "(Yazar Yıl)",
    inTextSuperscriptOrBracketed: "Üst simge veya parantezli sayılar (1)",
    inTextBracketedNumbers: "Köşeli parantezli sayılar [1]",
    inTextSuperscriptNumbers: "Üst simge sayılar¹",
    inTextSuperscriptOrAuthorYear: "Üst simge sayılar veya (Yazar Yıl)",
    inTextKeyBased: "Anahtar tabanlı referanslar",
    inTextSuperscriptOrAuthorCommaYear: "Üst simge sayılar veya (Yazar, Yıl)",
    inTextFootnotesCaseLegislation:
      "İçtihat ve mevzuat atıfları içeren dipnotlar",
    inTextFootnotesSignals: "Sinyal kısaltmaları içeren dipnotlar",
    inTextFootnotesPinpoint: "Kesin konum belirten dipnotlar",
    inTextParenNumbers: "Parantezli sayılar (1)",
    inTextItalicNumbers: "İtalik sayılar (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "4. baskı",
    edition5th: "5. baskı",
    edition7th: "7. baskı",
    edition8th: "8. baskı",
    edition9th: "9. baskı",
    edition11th: "11. baskı",
    edition18th: "18. baskı",
    edition22nd: "22. baskı",
    editionCiteThemRight11th: "Cite Them Right, 11. baskı",
    editionIcmjeStandard: "ICMJE standardı",
    editionStandard: "standart baskı",
    editionCurrent: "güncel baskı",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "akustik",
    fieldAnthropology: "antropoloji",
    fieldAppliedPhysics: "uygulamalı fizik",
    fieldArchaeology: "arkeoloji",
    fieldArts: "sanat",
    fieldAstrophysics: "astrofizik",
    fieldAustralianLaw: "avustralya hukuku",
    fieldBiochemistry: "biyokimya",
    fieldBiology: "biyoloji",
    fieldBiomedicalSciences: "biyomedikal bilimler",
    fieldBiotechnology: "biyoteknoloji",
    fieldBusiness: "işletme",
    fieldCellBiology: "hücre biyolojisi",
    fieldChemicalEngineering: "kimya mühendisliği",
    fieldChemistry: "kimya",
    fieldClinicalResearch: "klinik araştırmalar",
    fieldComputerScience: "bilgisayar bilimi",
    fieldCondensedMatter: "yoğun madde fiziği",
    fieldCourtDocuments: "mahkeme belgeleri",
    fieldCriminology: "kriminoloji",
    fieldCulturalStudies: "kültürel çalışmalar",
    fieldDemography: "demografi",
    fieldEcology: "ekoloji",
    fieldEducation: "eğitim",
    fieldElectronics: "elektronik",
    fieldEngineering: "mühendislik",
    fieldEnvironmentalScience: "çevre bilimi",
    fieldEpidemiology: "epidemiyoloji",
    fieldEthnography: "etnografya",
    fieldGenetics: "genetik",
    fieldGeology: "jeoloji",
    fieldGlobalHealth: "küresel sağlık",
    fieldHealthSciences: "sağlık bilimleri",
    fieldHistory: "tarih",
    fieldHumanities: "beşeri bilimler",
    fieldInformationSystems: "bilişim sistemleri",
    fieldInformationTechnology: "bilgi teknolojisi",
    fieldInternationalRelations: "uluslararası ilişkiler",
    fieldJurisprudence: "hukuk felsefesi",
    fieldLanguages: "diller",
    fieldLaw: "hukuk",
    fieldLawReview: "hukuk dergisi",
    fieldLegalStudies: "hukuk çalışmaları",
    fieldLifeSciences: "yaşam bilimleri",
    fieldLiterature: "edebiyat",
    fieldMaterialsScience: "malzeme bilimi",
    fieldMathematics: "matematik",
    fieldMedicine: "tıp",
    fieldMolecularBiology: "moleküler biyoloji",
    fieldMultidisciplinary: "disiplinlerarası",
    fieldMultidisciplinaryScience: "disiplinlerarası bilim",
    fieldNaturalSciences: "fen bilimleri",
    fieldNursing: "hemşirelik",
    fieldPharmacy: "eczacılık",
    fieldPhysics: "fizik",
    fieldPoliticalScience: "siyaset bilimi",
    fieldPsychology: "psikoloji",
    fieldPublicHealth: "halk sağlığı",
    fieldPublicPolicy: "kamu politikası",
    fieldPublishing: "yayıncılık",
    fieldScience: "bilim",
    fieldSciences: "bilimler",
    fieldSocialSciences: "sosyal bilimler",
    fieldSocialWork: "sosyal hizmet",
    fieldSociology: "sosyoloji",
    fieldSoftwareEngineering: "yazılım mühendisliği",
    fieldTheology: "teoloji",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "Sosyal bilimlerde en yaygın kullanılan atıf stili",
    mla: "Beşeri bilimler için standart atıf stili",
    chicago:
      "Amerika'nın yazarlar, editörler ve yayıncılar için en güvenilir stil kılavuzu",
    harvard:
      "İngiltere ve Avustralya üniversitelerinde en popüler kaynak gösterme stili",
    vancouver: "Tıp ve biyomedikal dergiler için standart atıf stili",
    ieee: "Mühendislik ve bilgisayar bilimi için başvurulan atıf stili",
    ama: "Amerikan tıp dergileri için atıf standardı",
    turabian: "Chicago stilinin öğrenci dostu sürümü",
    cse: "Doğa ve fen bilimleri için tercih edilen atıf stili",
    bibtex: "LaTeX kullanıcıları ve akademik dizgi için kaynakça biçimi",
    nature:
      "Dünyanın önde gelen çok disiplinli dergisinin kullandığı atıf stili",
    acs: "Kimya ve kimya bilimleri için atıf standardı",
    oscola:
      "İngiltere'deki hukuk fakülteleri ve dergileri için standart hukuki atıf stili",
    bluebook:
      "ABD mahkemeleri ve hukuk dergileri için kesin hukuki atıf sistemi",
    aglc: "Avustralya'daki hukuk fakülteleri ve mahkemeleri için standart hukuki atıf stili",
    asa: "Sosyoloji ve sosyal araştırmalar için standart atıf stili",
    apsa: "Siyaset bilimi araştırmaları ve dergileri için atıf stili",
    aaa: "Antropolojik araştırmalar için standart atıf stili",
    nlm: "PubMed ve ABD Ulusal Tıp Kütüphanesi'nin kullandığı atıf standardı",
    acm: "ACM konferansları ve bilgisayar bilimi araştırmaları için atıf stili",
    aps: "Physical Review ve APS dergileri için atıf stili",
    aip: "AIP ve fizik dergileri için atıf stili",
    cell: "Cell Press ve önde gelen biyoloji dergileri için atıf stili",
    science: "Science dergisi ve AAAS dergileri için atıf stili",
    plos: "PLOS açık erişim dergileri için atıf stili",
    bmj: "BMJ ve önde gelen İngiliz tıp dergileri için atıf stili",
    lancet: "The Lancet dergi ailesi için atıf stili",
    jama: "JAMA ve JAMA Network dergileri için atıf stili",
    elsevierHarvard: "Elsevier dergilerinde kullanılan Harvard stili varyantı",
    springer: "Springer Nature dergileri ve kitapları için atıf stili",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "Bulunamadı",
    metaTitle: "{a} vs {b} - temel farklar açıklandı [2026]",
    metaDescription:
      "{a} ve {b} atıf stillerini yan yana karşılaştırın. Ödeviniz için doğru stili seçebilmeniz adına biçimlendirme, metin içi atıflar ve kaynakça farklarını öğrenin.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "Metin içi biçim, kaynakça girdileri, büyük/küçük harf kullanımı ve her birinin hangi alanlarda gerekli olduğu.",
    ogKind: "Stil karşılaştırması",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} ile {b} karşılaştırması",
    keywordDifference: "{a} ve {b} arasındaki fark",
    keywordOr: "{a} veya {b}",
    keywordComparison: "atıf stili karşılaştırması",
    breadcrumbCompare: "Stilleri karşılaştır",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← Karşılaştırma aracına dön",
    heading: "{a} vs {b}: temel farklar",
    intro:
      "{a} ve {b}, akademik dünyada en yaygın kullanılan iki atıf stilidir; ancak önemli noktalarda birbirinden ayrılırlar. {introA} {introB} Bu farkları anlamak, ödeviniz için doğru biçimi seçmenize yardımcı olacaktır.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style}, birçok akademik alanda kullanılan popüler bir atıf stilidir.",
    tableHeading: "Yan yana karşılaştırma",
    tableFeature: "Özellik",
    tableCitationSystem: "Atıf sistemi",
    tableInText: "Metin içi biçim",
    tableReferenceList: "Liste adı",
    tableEdition: "Baskı",
    tableCommonFields: "Yaygın alanlar",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "Yazar–tarih",
    systemNumbered: "Numaralı",
    systemFootnotes: "Dipnot",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "parantez içi yazar–tarih",
    describeNumbered: "numaralı",
    describeFootnotes: "dipnota dayalı",
    whenToUseHeading: "{style} ne zaman kullanılır",
    whenToUseBody:
      "{style} ({fullName}), {system} bir atıf sistemi kullanır; metin içi atıflarda {inText} biçimini, kaynakçada ise {list} başlığını izler. En yaygın olarak {fields}{more} alanlarında kullanılır.",
    whenToUseMoreFields: " ve ilgili",
    whenToUseFallback:
      "{style}, yaygın olarak tanınan bir atıf stilidir. Gerekli biçimin {style} olup olmadığını doğrulamak için ödev yönergelerinizi veya hedef dergiyi kontrol edin.",
    ctaHeading: "Farkı uygulamada görün",
    ctaBodyBefore:
      "Kendi kaynaklarınızı kullanarak {a} ve {b} kaynak gösterimlerini yan yana karşılaştırmak için",
    ctaBodyLink: "etkileşimli karşılaştırma aracımızı",
    ctaBodyAfter: " deneyin.",
    ctaCiteIn: "{style} ile kaynak göster →",
    faqDifferenceQ: "{a} ile {b} arasındaki fark nedir?",
    faqDifferenceA:
      "{a} ve {b}; metin içi atıf biçimi, kaynakça yapısı ve kullanıldıkları akademik alanlar bakımından birbirinden farklıdır. {detail}",
    faqDifferenceDetail:
      "{a}, metin içi atıflarda {inTextA} biçimini ve kaynakçasında {listA} başlığını kullanırken; {b}, {inTextB} biçimini ve {listB} başlığını kullanır.",
    faqDifferenceDetailFallback:
      "Her stilin; atıfları biçimlendirme, kaynakçayı düzenleme ve farklı kaynak türlerini ele alma konusunda kendine özgü kuralları vardır.",
    faqBetterQ: "İkisinden hangisi daha iyidir: {a} veya {b}?",
    faqBetterA:
      "Ne {a} ne de {b} doğası gereği daha iyidir. Doğru seçim; akademik alanınıza, eğitmeninizin gerekliliklerine veya başvurduğunuz dergiye bağlıdır. Hangi stili kullanacağınızı belirlemek için ödev yönergelerinizi veya hedef yayını kontrol edin.",
    faqSwitchQ: "{a} ile {b} arasında geçiş yapabilir miyim?",
    faqSwitchA:
      "Evet, CitationEasy'nin ücretsiz kaynakça oluşturucusunu kullanarak {a} ile {b} arasında geçiş yapabilirsiniz. İstediğiniz stili seçmeniz yeterlidir; kaynaklarınız otomatik olarak yeniden biçimlendirilir. Ancak eğitmeniniz aksini belirtmediği sürece, bir ödevde yalnızca tek bir stil kullanmalısınız.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "Dönüştürücü bulunamadı",
    metaTitle: "{title} - ücretsiz ve anında",
    ogTitle: "{title}",
    ogKind: "Dönüştürücü",
    breadcrumbConverters: "Dönüştürücüler",
    breadcrumbLabel: "Gezinme yolu",
    whenHeading: "Bu ne zaman gerekir",
    relatedHeading: "İlgili dönüştürücüler",
    allConverters: "Tüm dönüştürücüler",
    formatConverterTool: "Atıf biçimi dönüştürücü",
    faqHowQ: "{input} biçimini {output} biçimine nasıl dönüştürebilirim?",
    faqHowA:
      "{intro} Her şey ücretsizdir; hesap gerekmez ve dönüştürme sınırı yoktur.",
    faqPrivacyQ: "Verilerim herhangi bir yere yükleniyor mu?",
    faqPrivacyIdentifier:
      "Her {input}, ilgili herkese açık meta veri servisinde aranır (DOI için Crossref, PMID için PubMed, ISBN için kütüphane kayıtları) ve yalnızca kimliğin kendisi gönderilir — belgeleriniz asla gönderilmez. Biçimlendirilmiş sonuçları kopyalayabilir veya indirebilirsiniz; hiçbir şey saklanmaz.",
    faqPrivacyLocal:
      "Hayır — yapıştırdığınız veya yüklediğiniz {input}, tamamen tarayıcınızda işlenir. {detail}",
    faqPrivacyDetailStyle:
      "Yalnızca ayrıştırılan kaynak alanları (yazar, başlık, yıl) atıfları oluşturmak üzere biçimlendiricimize gönderilir; dosyanızın kendisi cihazınızdan asla ayrılmaz.",
    faqPrivacyDetailOffline:
      "Dönüştürme işlemi tamamen çevrimdışı olarak, sayfanın içinde gerçekleşir — hiçbir şey herhangi bir sunucuya gönderilmez.",
    faqUsefulQ:
      "{input} biçiminden {output} biçimine dönüştürme ne zaman kullanışlıdır?",
    faqOtherQ: "Başka stillere ve biçimlere de dönüştürebilir miyim?",
    faqOtherA:
      "Evet. CitationEasy'nin oluşturucusu herhangi bir kaynağı {count} atıf stilinde biçimlendirir, kaynakça Word, RTF, BibTeX, RIS ve CSL-JSON olarak dışa aktarılabilir, dönüştürücü merkezinde ise her doğrudan dönüştürme çifti listelenir. Zaten biçimlendirilmiş bir metni bir stilden başka bir stile çevirmeniz gerekiyorsa, bunun yerine Atıf Biçimi Dönüştürücü aracını kullanın.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "DOI'den APA'ya Atıf Dönüştürücü",
    doiToApaMetaDescription:
      "DOI'leri yapıştırın (satır başına bir tane) ve yayıncının resmi Crossref meta verilerinden anında APA 7 kaynakçaları elde edin. Ücretsiz, hesap gerekmez.",
    doiToApaIntro:
      "Bir DOI zaten yayıncının yetkili meta verilerine işaret eder, bu yüzden APA kaynakçasını elle yazmaya gerek yoktur. Satır başına bir DOI yapıştırın; her biri eksiksiz bir APA 7 kaynağına dönüştürülür — yazar adları ters çevrilir, başlık cümle biçiminde yazılır, dergi adı italik olur ve APA'nın gerektirdiği https://doi.org/ bağlantısı eklenir.",
    doiToApaUseCase:
      "Tipik an: hocanız APA kaynakça listesi istiyor, elinizde ise okurken kaydettiğiniz bir yığın DOI var. Yığını yapıştırın, listeyi kopyalayın.",
    doiToMlaTitle: "DOI'den MLA'ya Atıf Dönüştürücü",
    doiToMlaMetaDescription:
      "Crossref meta verilerini kullanarak DOI'leri otomatik olarak MLA 9 kaynakça girdilerine dönüştürün. Satır başına bir DOI yapıştırın — ücretsiz, kurulum gerekmez.",
    doiToMlaIntro:
      "MLA 9, bir dergi makalesini bir kapsayıcı zinciri olarak ele alır — tırnak içinde makale başlığı, italik dergi adı, cilt, sayı, yıl, sayfalar — bunları elle bir araya getirmek uğraştırıcıdır. DOI sorgusu her alanı yayıncının kaydından doldurur, böylece kaynakça girdisi ilk seferinde doğru çıkar.",
    doiToMlaUseCase:
      "Beşeri bilimler dersi MLA gerektirdiğinde ama kaynaklarınız yalnızca DOI veren fen bilimleri ağırlıklı veri tabanlarından geldiğinde işe yarar.",
    doiToBibtexTitle: "DOI'den BibTeX'e Dönüştürücü",
    doiToBibtexMetaDescription:
      "DOI'leri LaTeX ve Overleaf için BibTeX girdilerine dönüştürün. Satır başına bir DOI yapıştırın, hazır bir .bib dosyası indirin — ücretsiz ve sınırsız.",
    doiToBibtexIntro:
      "Her LaTeX makalesinin er ya da geç bir .bib dosyasına ihtiyacı olur. DOI'leri satır satır yapıştırın; Overleaf, natbib veya biblatex için hazır, oluşturulmuş atıf anahtarlarına sahip temiz @article girdileri elde edin — yayıncı sayfalarından alanları elle kopyalamaya gerek kalmaz.",
    doiToBibtexUseCase:
      "Klasik akış: bir hakem sizden alıntılanacak üç makale gönderir, DOI'leri elinizde vardır ve teslim tarihiniz bu akşamdır. Yapıştırın, indirin, \\cite kullanın.",
    doiToRisTitle: "DOI'den RIS'e Dönüştürücü",
    doiToRisMetaDescription:
      "DOI'leri Zotero, Mendeley ve EndNote'un doğrudan içe aktardığı bir RIS dosyasına dönüştürün. DOI'leri satır satır yapıştırın — ücretsiz, kayıt gerekmez.",
    doiToRisIntro:
      "RIS, her referans yöneticisinin içe aktardığı değişim formatıdır. DOI'leri yapıştırın; TY/AU/TI/T2 alanları doğrudan Crossref'ten gelen bir .ris dosyası indirin — ardından Dosya → İçe Aktar ile Zotero, Mendeley veya EndNote'a aktarın; kayıtlar tam yapılandırılmış olarak gelir.",
    doiToRisUseCase:
      "Elle toplanmış bir DOI listesini, tek bir yazar adını yeniden yazmadan gerçek bir referans yöneticisine taşımak için idealdir.",
    isbnToApaTitle: "ISBN'den APA'ya Atıf Dönüştürücü",
    isbnToApaMetaDescription:
      "ISBN'leri otomatik olarak APA 7 kitap kaynakçalarına dönüştürün. Satır başına bir ISBN yapıştırın ve biçimlendirilmiş listeyi kopyalayın — ücretsiz, hesap gerekmez.",
    isbnToApaIntro:
      "Bir kitabın telif hakkı sayfasındaki ISBN, APA kaynakçası için ihtiyacınız olan tek şeydir. Her ISBN, kütüphane meta verileriyle eşleştirilir ve APA 7 biçiminde düzenlenir — yazar, yıl, italik başlık ve yayınevi — kayıtta bulunuyorsa baskı bilgisi de dahil edilir.",
    isbnToApaUseCase:
      "Bir yığın fiziksel kütüphane kitabını kaynak göstermenin en hızlı yolu: her birinin telif hakkı sayfasını açın, ISBN'leri yazın, listeyi buraya yapıştırın.",
    isbnToMlaTitle: "ISBN'den MLA'ya Atıf Dönüştürücü",
    isbnToMlaMetaDescription:
      "ISBN'leri tek seferde MLA 9 kaynakça girdilerine dönüştürün. Ücretsiz ISBN sorgulama ve biçimlendirilmiş çıktı — kayıt gerekmez.",
    isbnToMlaIntro:
      "MLA 9 kitap girdileri kısadır — yazar, italik başlık, yayınevi, yıl — ancak yazar adının doğru ters çevrilmesi ve noktalama işaretleri yine de kafa karıştırabilir. ISBN sorgusu, kitabın gerçek katalog kaydını getirir ve MLA el kitabının temel öğeler şablonuna göre biçimlendirir.",
    isbnToMlaUseCase:
      "Edebiyat ödevleri için idealdir: masanızdaki her romanı ve eleştirel monografiyi, yalnızca arka kapaktaki numarayı yazarak kaynak gösterin.",
    isbnToBibtexTitle: "ISBN'den BibTeX'e Dönüştürücü",
    isbnToBibtexMetaDescription:
      "ISBN'leri LaTeX için BibTeX @book girdilerine dönüştürün. Satır başına bir ISBN yapıştırın, .bib dosyasını indirin — ücretsiz ve anında.",
    isbnToBibtexIntro:
      "Kitaplar BibTeX'in can sıkıcı köşesidir — aranacak bir DOI yoktur ve yayınevi sayfaları nadiren .bib dışa aktarımı sunar. Bu dönüştürücü her ISBN'i kütüphane meta verileriyle eşleştirir ve yazar, başlık, yayınevi ile yıl alanları doldurulmuş @book girdileri üretir.",
    isbnToBibtexUseCase:
      "Tez yazarları için: yöntem bölümleri dergi DOI'lerini kaynak gösterir, ancak kuram bölümü on iki kitaba atıfta bulunur. Bu on iki kitabı bu dönüştürücü halleder.",
    pmidToApaTitle: "PMID'den APA'ya Atıf Dönüştürücü",
    pmidToApaMetaDescription:
      "PubMed ID'lerini otomatik olarak APA 7 kaynakçalarına dönüştürün. PMID'leri satır satır yapıştırın ve biçimlendirilmiş bir kaynakça listesi elde edin — ücretsiz.",
    pmidToApaIntro:
      "Her PubMed kaydının bir PMID'si vardır ve psikoloji ile hemşirelik programları büyük ölçüde APA gerektirir. PMID'leri satır satır yapıştırın; her biri PubMed'in kendi meta verileri üzerinden, kayıtta varsa DOI bağlantısı da dahil olmak üzere eksiksiz bir APA 7 dergi kaynağına dönüştürülür.",
    pmidToApaUseCase:
      "Kanıta dayalı uygulama ödevleri için tasarlanmıştır: arama stratejiniz bir PMID listesiyle sonuçlanır ve ödeviniz bunları APA biçiminde ister.",
    pmidToRisTitle: "PMID'den RIS'e Dönüştürücü",
    pmidToRisMetaDescription:
      "PubMed ID'lerini Zotero, Mendeley veya EndNote için bir RIS dosyasına dönüştürün. PMID'leri satır satır yapıştırın, .ris dosyasını indirin — ücretsiz.",
    pmidToRisIntro:
      "Sistematik derleme iş akışları RIS dosyalarına dayanır. PubMed aramanızdan elde ettiğiniz PMID'leri yapıştırın ve tarama aracınız veya referans yöneticiniz için hazır bir .ris dosyası indirin — her kayıt, kazınmış metin yerine PubMed'in kendi standart meta verilerinden yapılandırılır.",
    pmidToRisUseCase:
      "Derleme sürecinin ortasında işe yarar: bir meslektaşınız size e-postayla salt PMID olarak beş çalışma daha gönderip 'bunları da ekle' dediğinde ve kütüphaneniz EndNote'ta duruyorsa.",
    arxivToBibtexTitle: "arXiv'den BibTeX'e Dönüştürücü",
    arxivToBibtexMetaDescription:
      "arXiv kimliklerini LaTeX makaleleri için BibTeX girdilerine dönüştürün. 2301.12345 gibi kimlikleri satır başına bir tane olacak şekilde yapıştırın ve .bib dosyasını indirin — ücretsiz.",
    arxivToBibtexIntro:
      "Hızlı ilerleyen alanlarda ön baskılar (preprint) sürekli olarak kaynak gösterilir ve arXiv kimlikleri (2301.12345 gibi) bunların dolaşım şeklidir. Kimlikleri yapıştırın; ön baskının yazarları, başlığı, yılı ve arXiv bağlantısını içeren, makalenizin .bib dosyasına hazır BibTeX girdileri elde edin.",
    arxivToBibtexUseCase:
      "İlgili çalışmalar bölümünün yüzde 80'i arXiv'den oluşan makine öğrenmesi ve fizik yazarları için: kimlikleri okurken toplayın, yazma aşamasında tek seferde dönüştürün.",
    bibtexToApaTitle: "BibTeX'ten APA'ya Dönüştürücü",
    bibtexToApaMetaDescription:
      "Bir .bib dosyası yapıştırın veya yükleyin, APA 7 kaynakça listesi elde edin. Çok girdili dosyaları da işler — ücretsiz, ayrıştırma tarayıcınızda gerçekleşir.",
    bibtexToApaIntro:
      "Bazen makale LaTeX'ten çıkar: bir dergi Word ile başvuru ister ya da bir komite kaynakça listesini düz metin olarak ister. BibTeX'inizi yapıştırın (veya .bib dosyanızı yükleyin); her girdi tarayıcınızda ayrıştırılır ve ardından herhangi bir belgeye yapıştırabileceğiniz bir APA 7 kaynakça listesi olarak biçimlendirilir.",
    bibtexToApaUseCase:
      "Burs/hibe başvurularının klasik örneği: yayın listeniz bir .bib dosyasında duruyordur ve fon kuruluşunun formu bir metin kutusunda APA biçiminde kaynakça ister.",
    bibtexToMlaTitle: "BibTeX'ten MLA'ya Dönüştürücü",
    bibtexToMlaMetaDescription:
      "BibTeX'i MLA 9 kaynakça girdilerine dönüştürün. .bib dosyasını yapıştırın veya yükleyin, biçimlendirilmiş listeyi kopyalayın — ücretsiz, hesap gerekmez.",
    bibtexToMlaIntro:
      "BibTeX ham alanları saklar; MLA ise bunların nasıl düzenleneceğini tam olarak belirler. Bu dönüştürücü .bib girdilerinizi tarayıcınızda yerel olarak ayrıştırır ve her birini MLA 9 şablonu üzerinden oluşturur — yazar adının ters çevrilmesi, tırnak içindeki makale başlıkları, italik kapsayıcılar ve öğeler arasındaki doğru noktalama işaretleri.",
    bibtexToMlaUseCase:
      "Alanlar arası geçiş yapan akademisyenler için: kaynaklarınız geçmiş LaTeX çalışmalarından kalma BibTeX biçimindedir, ama başvurduğunuz beşeri bilimler dergisi MLA istemektedir.",
    bibtexToRisTitle: "BibTeX'ten RIS'e Dönüştürücü",
    bibtexToRisMetaDescription:
      "Bir .bib dosyasını Zotero, Mendeley veya EndNote için RIS'e dönüştürün. BibTeX'i yapıştırın veya yükleyin, .ris dosyasını indirin — ücretsiz ve çevrimdışı.",
    bibtexToRisIntro:
      "LaTeX araçlarından bir referans yöneticisine geçmek, BibTeX'in @article/@book girdilerini RIS'in TY/AU/TI etiketlerine çevirmek anlamına gelir. Dönüştürme işlemi tamamen tarayıcınızda gerçekleşir — alan eşlemeleri dahil — ve size herhangi bir yöneticinin içe aktarabileceği bir .ris dosyası verir.",
    bibtexToRisUseCase:
      "Tipik tetikleyici: yeni bir ortak yazar Zotero kullanıyordur, paylaşılan kaynaklarınız depodaki bir .bib dosyasındadır ve birinin bu farkı kapatması gerekir.",
    bibtexToCslJsonTitle: "BibTeX'ten CSL-JSON'a Dönüştürücü",
    bibtexToCslJsonMetaDescription:
      "BibTeX'i Pandoc ve Quarto için CSL-JSON'a dönüştürün. .bib dosyasını yapıştırın veya yükleyin, references.json dosyasını indirin — ücretsiz, tarayıcı içinde.",
    bibtexToCslJsonIntro:
      "Pandoc ve Quarto, kaynakları doğrudan CSL-JSON'dan gösterir; mevcut .bib dosyanızı dönüştürmek, derleme sürecinden hareketli bir parçayı kaldırır. Girdiler tarayıcınızda ayrıştırılır ve --bibliography=references.json'ın beklediği tam biçimde, temiz bir CSL-JSON dizisi olarak ortaya çıkar.",
    bibtexToCslJsonUseCase:
      "Eski bir LaTeX projesini Quarto'ya taşıyan, Markdown öncelikli akademisyenler için: kaynakçayı elle JSON düzenlemeden birlikte taşıyın.",
    bibtexToWordTitle: "BibTeX'ten Word'e Dönüştürücü",
    bibtexToWordMetaDescription:
      "Bir .bib dosyasını, APA biçiminde asılı girintili bir kaynakça listesi içeren Word belgesine dönüştürün. Ücretsiz — ayrıştırma tarayıcınızda gerçekleşir.",
    bibtexToWordIntro:
      "Bir .bib dosyasının başka bir veri biçimine değil, bir belgeye dönüşmesi gerektiğinde, bu dönüştürücü BibTeX'inizi yerel olarak ayrıştırır, her girdiyi APA 7'de biçimlendirir ve kaynakça listesi zaten alfabetik sıraya dizilmiş ve asılı girintili bir Word dosyası indirir.",
    bibtexToWordUseCase:
      "Sürecin son adımı: dergi makaleyi kabul etti ama son kaynakça listesini düzenlenebilir bir Word dosyası olarak istiyor ve sizin tek doğru kaynağınız BibTeX.",
    risToApaTitle: "RIS'ten APA'ya Dönüştürücü",
    risToApaMetaDescription:
      "Bir RIS dışa aktarımını yapıştırın veya yükleyin, APA 7 kaynakça listesi elde edin. Zotero, Mendeley, EndNote ve veri tabanı dışa aktarımlarıyla çalışır — ücretsiz.",
    risToApaIntro:
      "Her veri tabanının Dışa Aktar düğmesi RIS üretir; ödevler ise APA ister. Dışa aktarımı yapıştırın (veya .ris dosyanızı yükleyin); her TY/AU/TI kaydı tarayıcınızda ayrıştırılır ve bir APA 7 kaynağı olarak oluşturulur — referans yöneticisi kurulumu gerekmez.",
    risToApaUseCase:
      "Kütüphane veri tabanı kısayolu: arama sonuçlarınızı RIS olarak dışa aktarın, burada dönüştürün ve tek seferlik bir ödev için Zotero kurmaktan kurtulun.",
    risToMlaTitle: "RIS'ten MLA'ya Dönüştürücü",
    risToMlaMetaDescription:
      "Veri tabanlarından veya referans yöneticilerinden alınan RIS dışa aktarımlarını MLA 9 kaynakça girdilerine dönüştürün. Yapıştırın veya yükleyin — ücretsiz, kayıt gerekmez.",
    risToMlaIntro:
      "JSTOR, ProQuest ve EBSCO hepsi RIS dışa aktarır, İngiliz dili ve edebiyatı bölümleri ise hepsi MLA ister. Bu sayfa o farkı kapatır: kayıtlar yerel olarak ayrıştırılır ve MLA 9 temel öğeler şablonu üzerinden oluşturulur, kaynakça sayfanıza yapıştırmaya hazır hale gelir.",
    risToMlaUseCase:
      "Ödevin teslim tarihinden önceki gece için tasarlandı: JSTOR'dan citations.ris olarak dışa aktarılmış on kaynak ve bunları elle biçimlendirme isteği sıfır.",
    risToBibtexTitle: "RIS'ten BibTeX'e Dönüştürücü",
    risToBibtexMetaDescription:
      "RIS'i LaTeX ve Overleaf için BibTeX'e dönüştürün. .ris dışa aktarımını yapıştırın veya yükleyin, temiz bir .bib dosyası indirin — ücretsiz, tarayıcı içinde.",
    risToBibtexIntro:
      "LaTeX yönünde ilerlerken: referans yöneticileri ve veri tabanları RIS konuşur, makalenizin derlemesi ise .bib ister. Kayıtlar tamamen tarayıcınızda dönüştürülür — türler TY etiketlerinden eşlenir, atıf anahtarları oluşturulur — ve Overleaf'in olduğu gibi kabul ettiği bir dosya elde edersiniz.",
    risToBibtexUseCase:
      "İş birliklerinde sık görülür: Zotero kullanan kişi RIS dışa aktarır, LaTeX kullanan kişi bunu bu sayfadan geçirir ve her ikisi de kendi araçlarını kullanmaya devam eder.",
    risToCslJsonTitle: "RIS'ten CSL-JSON'a Dönüştürücü",
    risToCslJsonMetaDescription:
      "Pandoc ve Quarto işlem hatları için RIS dışa aktarımlarını CSL-JSON'a dönüştürün. .ris dosyasını yapıştırın veya yükleyin, references.json dosyasını indirin — ücretsiz.",
    risToCslJsonIntro:
      "Pandoc ve Quarto kullanıcıları için CSL-JSON, yerel kaynakça biçimidir. Veri tabanınızın veya yöneticinizin dışa aktardığı RIS'i bu sayfaya verin ve yapılandırılmış bir JSON dizisi geri alın — her kayıt yerel olarak ayrıştırılır, hiçbir şey herhangi bir yere yüklenmez.",
    risToCslJsonUseCase:
      "Docs-as-code iş akışlarına uyar: hakemler RIS ekleri gönderir, deponuzun kaynakça dosyası references.json'dır, bu sayfa da aradaki bağlayıcıdır.",
    cslJsonToBibtexTitle: "CSL-JSON'dan BibTeX'e Dönüştürücü",
    cslJsonToBibtexMetaDescription:
      "CSL-JSON'ı (Pandoc/Quarto/Zotero dışa aktarımları) BibTeX'e dönüştürün. .json dosyasını yapıştırın veya yükleyin, .bib dosyasını indirin — ücretsiz, tarayıcı içinde.",
    cslJsonToBibtexIntro:
      "Bazen akış tersine döner: bir Pandoc veya Zotero işlem hattında oluşan kaynakça, bir LaTeX derlemesini beslemek zorundadır. Bu dönüştürücü, tarayıcınızdaki CSL-JSON dizisini okur ve türleri ile alanları CSL modelinden geri eşlenmiş BibTeX girdileri üretir.",
    cslJsonToBibtexUseCase:
      "Ortak yazarı Overleaf'te ısrar eden Quarto yazarları için: references.json dosyasını asıl kaynak olarak koruyun ve .bib dosyasını istediğinizde oluşturun.",
    cslJsonToRisTitle: "CSL-JSON'dan RIS'e Dönüştürücü",
    cslJsonToRisMetaDescription:
      "Zotero, Mendeley veya EndNote'un içe aktarabilmesi için CSL-JSON'ı RIS'e dönüştürün. .json dosyasını yapıştırın veya yükleyin, .ris dosyasını indirin — ücretsiz.",
    cslJsonToRisIntro:
      "CSL-JSON, Pandoc işlem hatları içinde harikadır ama çoğu referans yöneticisinin içe aktarma penceresi için anlaşılmazdır. RIS'e dönüştürmek aynı kayıtları evrensel olarak içe aktarılabilir hale getirir — her öğe tarayıcınızda TY/AU/TI etiketlerine eşlenir, hiçbir şey bir sunucuya gönderilmez.",
    cslJsonToRisUseCase:
      "Teslim etme sorunu: kaynakçanız bir git deposundaki references.json dosyasıdır ve danışmanınız onu cumaya kadar 'EndNote'ta' istemektedir.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "Tüm atıf stilleri",
    styleSingular: "stil",
    stylePlural: "stil",
    found: "bulundu",
    filterPlaceholder: "Stilleri filtrele...",
    noMatches: "Aramanızla eşleşen stil bulunamadı.",
    loadingMore: "Daha fazla stil yükleniyor...",
    loadMore: "Daha fazla yükle ({count} kaldı)",
    showingAll: "Tüm {count} stil gösteriliyor",
    internationalLabel: "Uluslararası",
  },

  footer: {
    tagline:
      "{count} stille ücretsiz bir kaynakça oluşturucu. Hesap yok, ücretli abonelik yok, sınır yok.",
    freeTools: "Ücretsiz araçlar",
    resources: "Kaynaklar",
    legal: "Yasal",
    language: "Dil",
    languageLabel: "Dilinizi seçin",
    rights:
      "Kaynak gösterimleri, Citation Style Language'in resmî tanımlarıyla biçimlendirilir.",
    popularStyles: "Popüler stiller",
    about: "Hakkında",
    privacy: "Gizlilik",
    terms: "Koşullar",
    contact: "İletişim",
    copyright: "© {year} CitationEasy. Ücretsiz kullanılır.",
    poweredBy: "Altyapı:",
    allTools: "Tüm yazma araçları",
    citationGuides: "Kaynak gösterme rehberleri",
    allStyles: "Tüm kaynak gösterme stilleri",
    citationGlossary: "Kaynak gösterme sözlüğü",
    howToCiteAny: "Her kaynak nasıl gösterilir",
  },

  faq: {
    heading: "Sık sorulan sorular",
    homeQ1: "CitationEasy gerçekten ücretsiz mi?",
    homeA1:
      "Evet. CitationEasy tamamen ücretsizdir: kayıt yok, sınır yok, ücretli sürüm yok. {count} kaynak gösterme stilinin tamamı herkese açıktır.",
    homeQ2: "Hangi kaynak gösterme stilleri destekleniyor?",
    homeA2:
      "Citation Style Language projesindeki {count} stilin tamamı; aralarında APA 7. baskı, MLA 9. baskı, Chicago, Harvard, Vancouver, IEEE, AMA ve Turabian var.",
    homeQ3: "Hesap açmam gerekiyor mu?",
    homeA3:
      "Hayır. CitationEasy tamamen tarayıcınızda çalışır ve kaynakçanız kendi cihazınızda saklanır. Hiçbir şey sunucuya yüklenmez, kaydolunacak bir yer de yoktur.",
    homeQ4: "Kaynakçamı kendi dilimde oluşturabilir miyim?",
    homeA4:
      "Evet. Kaynakça dili, site dilinden ayrı bir ayardır; böylece Türkçe çalışırken kaynakları ödevinizin yazıldığı dilde üretebilirsiniz.",
    styleQ1: "{style} kaynak gösterme aracı ücretsiz mi?",
    styleA1:
      "Evet. {style} kaynak gösterimleri oluşturmak ücretsiz ve sınırsızdır, hesap gerekmez. Bir DOI, URL, ISBN veya BibTeX kaydı yapıştırın ve hazır kaynağı kopyalayın.",
    styleQ2: "{style} biçiminde bir kaynak nasıl gösterilir?",
    styleA2:
      "Kaynağın DOI, URL, ISBN veya BibTeX kaydını bu sayfadaki araca yapıştırın. {style} zaten seçili olduğu için kaynak gösterimi ve metin içi atıf anında görünür.",
    styleQ3: "{style} biçimlendirmesi ne kadar doğru?",
    styleA3:
      "Her kaynak, Citation Style Language projesinin yayımladığı resmî {style} tanımından üretilir — Zotero ve Mendeley'in kullandığı dosyanın aynısı — kuralların yaklaşık bir yorumundan değil.",
  },

  tool: {
    modeLabel: "Kaynak girişi modu",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "Kitap ara",
    modeArticles: "Makale ara",
    modeManual: "Elle giriş",
    errorEnterManually: "Bilgileri elle girin",
    autoLabel: "URL, DOI, PMID, arXiv kimliği, ISBN veya BibTeX yapıştırın",
    autoHint:
      "Türü otomatik olarak algılar ve üst verileri getiririz. Bütün bir listeyi tek seferde kaynak göstermek için her satıra bir tanımlayıcı yapıştırın.",
    generate: "Kaynak oluştur",
    generating: "Oluşturuluyor…",
    bookSearchLabel: "Başlık, yazar veya ISBN ile arayın",
    bookSearchEmpty: "Henüz sonuç yok. Kitap bulmak için Ara’ya tıklayın.",
    bookSearchSource: "Milyonlarca kitap içeren Open Library kataloğunda arar",
    worksSearchLabel: "Makale başlığı veya yazarlarla arayın",
    worksSearchEmpty: "Henüz sonuç yok. Makale bulmak için Ara’ya tıklayın.",
    worksSearchSource:
      "Crossref kataloğunda arar: dergi makaleleri, konferans bildirileri ve kitap bölümleri",
    showingResults: "{total} sonuçtan {shown} tanesi gösteriliyor",
    search: "Ara",
    searching: "Aranıyor…",
    bulkResults: "Toplu kaynak sonuçları",
    copy: "Kopyala",
    copied: "Kopyalandı!",
    copyHint: "Kopyalayıp ödevinize yapıştırın",
    resultTitle: "Biçimlendirilmiş kaynak",
    edit: "Düzenle",
    completeFields: "Tamamla",
    fieldsIncomplete: "other:{count} alan eksik",
    outputLanguage: "Dil",
    sourceType: "Kaynak türü",
    fieldAuthors: "Yazar(lar)",
    fieldAuthorsHint: "Yılmaz, Ayşe veya Ayşe Yılmaz",
    fieldTitle: "Makale veya kitap başlığı",
    fieldBookTitle: "Kitap başlığı",
    fieldBookTitleHint: "Kitabın veya derlemenin başlığı",
    fieldEditors: "Editör(ler)",
    fieldJournal: "Dergi / yayın",
    fieldJournalHint: "Dergi veya yayın adı",
    fieldPublisher: "Yayıncı / site",
    fieldPublisherHint: "Yayıncı adı veya web sitesi",
    fieldDate: "Tarih / yıl",
    fieldVolume: "Cilt",
    fieldIssue: "Sayı",
    fieldPages: "Sayfa(lar)",
    fieldFormat: "Biçim / ortam",
    fieldAuthorsGroup: "Kurumsal veya grup yazar",
    fieldAuthorsGroupHint:
      "Bir grubu kişilerle birlikte yazmak için süslü paranteze alın: {R Core Team}, Ayşe Yılmaz",
    fieldTranslators: "Çevirmen(ler)",
    fieldInterviewers: "Görüşmeci(ler)",
    fieldVersion: "Sürüm",
    fieldCourt: "Mahkeme",
    fieldIssuingAuthority: "Veren makam",
    fieldPatentNumber: "Patent numarası",
    fieldEpisodeNumber: "Bölüm numarası",
    fieldLawNumber: "Kanun veya tasarı numarası",
    fieldReportNumber: "Rapor numarası",
    fieldReviewedTitle: "İncelenen eserin başlığı",
    fieldReviewedAuthors: "İncelenen eserin yazar(lar)ı",
    inTextCitation: "Metin içi kaynak",
    quickEdit: "Hızlı düzenle",
    quickEditHint: "Üst verileri güncelleyip kaynağı yeniden oluşturun.",
    update: "Güncelle",
    saving: "Kaydediliyor…",
    fieldAuthor: "Yazar",
    fieldDateShort: "Tarih",
    fieldTitleShort: "Başlık",
  },

  toolCollections: {
    "citation-generators": "Atıf oluşturucular",
    "citation-tools": "Atıf ve kaynakça araçları",
    "paper-formatting": "Ödev biçimlendirme",
    "essay-writing": "Deneme ve ödev yazımı",
    "writing-analysis": "Yazı analizi ve düzenleme",
    "word-counters": "Sayaçlar ve okunabilirlik",
    vocabulary: "Kelime dağarcığı ve kelime bulucular",
    "research-tools": "Araştırma ve yayın",
    statistics: "İstatistik hesaplayıcıları",
    math: "Matematik hesaplayıcıları",
    science: "Fen ve laboratuvar hesaplayıcıları",
    charts: "Grafikler ve diyagramlar",
    economics: "Ekonomi, işletme ve finans",
    grades: "GPA ve not hesaplayıcıları",
    study: "Çalışma ve verimlilik",
    classroom: "Sınıf ve yazdırılabilir materyaller",
    random: "Rastgele oluşturucular ve seçiciler",
    "text-tools": "Metin temizleme ve biçimlendirme",
    "fancy-text": "Süslü metin ve semboller",
    language: "Dil ve harf çevirisi",
    ciphers: "Kodlar ve şifreler",
    converters: "Birim, tarih ve sayı dönüştürücüler",
    developer: "Veri, işaretleme ve kod",
  },
  bib: {
    title: "Kaynakçalarım",
    studioTitle: "Kaynakça Stüdyosu",
    studioProjects: "Projeler",
    studioExplore: "Keşfet",
    studioExploreIntro:
      "Rehberler, araçlar ve tüm atıf stilleri tek tık uzağınızda.",
    studioStyleGuide: "{style} stil rehberi",
    studioStyleGuideHint: "Kurallar, çözümlü örnekler ve metin içi biçim",
    studioGenerator: "Atıf oluşturucu",
    studioNewProject: "Yeni proje",
    studioSwitchProject: "Proje değiştir",
    studioAddSource: "Kaynak ekle",
    studioAddSourceHint:
      "Bir DOI, URL veya ISBN yapıştırın, kitap ve makale arayın ya da bilgileri elle girin. Kaydettiğiniz her şey bu projeye eklenir.",
    studioDoneAdding: "Bitti",
    studioReferences: "Kaynakça",
    studioReferenceCount: "{count} kaynak",
    studioInspectorTitle: "Kaynak ayrıntıları",
    studioInspectorEmpty:
      "Metin içi atfını, notlarını ve kaynak ayrıntılarını görmek için bir kaynak seçin.",
    studioSavedLocally: "Bu tarayıcıda kaydedildi",
    studioOpen: "Kaynakça Stüdyosu’nu aç",
    studioViewInStudio: "Stüdyoda görüntüle",
    studioFooterSaved: "Kaynakça Stüdyonuzda {count} kayıt",
    studioFooterEmpty: "Kaydedilen atıflar Stüdyoda tam bir kaynakça oluşturur",
    studioClearSelection: "Seçimi temizle",
    studioDeleteSelected: "Seçilenleri sil",
    studioDeleteSelectedBody:
      "“{name}” içindeki {count} atıf silinsin mi? Bu işlem geri alınamaz.",
    studioDeletedMany: "{count} atıf silindi",
    studioMoveTo: "Şuraya taşı",
    studioCopyTo: "Şuraya kopyala",
    studioSearchShortcut: "Aramak için / tuşuna basın",
    studioStyle: "Stil",
    studioCopyEntry: "Girdiyi kopyala",
    studioEntryCopied: "Girdi kopyalandı",
    studioSourceDetails: "Kaynak ayrıntıları",
    studioEmptyTitle: "Bu proje boş",
    studioEmptyBody:
      "Yukarıdan ilk kaynağınızı ekleyin veya mevcut bir BibTeX, RIS ya da CSL-JSON kitaplığını içe aktarın.",
    studioBackup: "Yedek",
    sharedTitle: "Paylaşılan kaynakça",
    save: "Kaydet",
    saving: "Kaydediliyor…",
    saved: "Kaydedildi",
    searchPlaceholder: "Kaynaklarda ara…",
    empty: "Henüz kaydedilmiş kaynak yok",
    emptySearch: "Aramanızla eşleşen kaynak yok.",
    countIn: "{name} içindeki kaynaklar: {count}",
    savedOn: "{date} tarihinde kaydedildi",
    emptyInBib:
      "Bu kaynakçada henüz kaynak yok. Kaynak oluşturup kaydedin ya da mevcut bir BibTeX, RIS veya CSL-JSON kitaplığını içe aktarın.",
    savedToast: "Kaynak kaynakçaya kaydedildi",
    copyAll: "Tümünü kopyala",
    copyAllTitle: "Tüm kaynakları kopyala",
    export: "Dışa aktar",
    exportTitle: "Kaynakçayı dışa aktar",
    import: "İçe aktar",
    importTitle: "Kaynak içe aktar",
    importLabel: "Kaynak içe aktar (BibTeX, RIS veya CSL-JSON)",
    importing: "İçe aktarılıyor…",
    importFailed: "İçe aktarma başarısız. Lütfen tekrar deneyin.",
    importSummary:
      "İçe aktarılan: {added} · Atlanan yinelenen: {duplicates} · Limit üstü: {overLimit} · Başarısız: {failed}",
    importUnreadable: "Dosya okunamadı.",
    importUnparseable: "Kaynaklar içe aktarılamadı.",
    importReviewTitle: "İçe aktarımı gözden geçir",
    importReviewIntro:
      "{total} {format} kaynağını biçimlendirip kaydetmeden önce gözden geçirin.",
    importReviewCount: "{total} kaynaktan {included} tanesi dahil",
    importSelectAll: "Tümünü dahil et",
    importExcludeAll: "Tümünü hariç tut",
    importLimitNotice:
      "200 kayıt sınırını aşan {count} kaynak içe aktarılmayacak.",
    importDuplicateExisting: "Kayıtlı “{title}” kaynağının olası kopyası",
    importDuplicateBatch:
      "Bu içe aktarımdaki “{title}” kaynağının olası kopyası",
    importMissingField: "{field} eksik",
    importUntitled: "Başlıksız kaynak",
    importReview: "Kaynakları gözden geçir",
    importCommit: "Biçimlendir ve içe aktar",
    importBack: "Geri",
    importOutcomeTitle: "İçe aktarma tamamlandı",
    importOutcomeSummary:
      "Eklendi: {added} · Yinelenenler atlandı: {duplicates} · Hariç tutuldu: {excluded} · Sınır üstü: {overLimit} · Başarısız: {failed}",
    sortBy: "Sıralama ölçütü",
    sortTitle: "Kaynakçayı sırala",
    sortAuthor: "Yazar (A–Z)",
    sortNewest: "Eklenme tarihi (en yeni)",
    sortOldest: "Yıl (en eski önce)",
    sortManual: "El ile sıralama",
    backupAll: "Tam proje yedeği (.json)",
    backupDownloaded: "Tam proje yedeği indirildi",
    backupUnreadable: "Yedek dosyası okunamadı.",
    restore: "Geri yükle",
    restoreTitle: "Tüm kaynakça projelerini geri yükle",
    restoreWarning:
      "Yedek önce doğrulanır, ardından bu tarayıcıda kayıtlı tüm kaynakçaların yerini alır. Bu işlem geri alınamaz.",
    restoreChoose: "Bir CitationEasy yedeği seçin (.json)",
    replaceAndRestore: "Değiştir ve geri yükle",
    restoreComplete: "Tüm kaynakça projeleri geri yüklendi",
    restoreInvalid: "Bu geçerli bir CitationEasy proje yedeği değil.",
    selectAllVisible: "Gösterilenlerin tümünü seç",
    selectedCount: "{count} seçildi",
    clusterOpen: "Birlikte alıntıla",
    clusterTitle: "Birleşik metin içi alıntı",
    clusterDescription:
      "Seçilen kaynaklardan tek bir alıntı kümesi oluşturun. Seçilen stil sıralamayı, noktalama işaretlerini ve numaralandırmayı belirler.",
    clusterTarget: "Çıktı",
    clusterLocatorOptional: "İsteğe bağlı konum",
    clusterBuildCopy: "Alıntıyı oluştur ve kopyala",
    clusterBuilding: "Alıntı oluşturuluyor…",
    clusterCopied: "Birleşik alıntı kopyalandı",
    clusterFailed: "Birleşik alıntı oluşturulamadı. Lütfen tekrar deneyin.",
    destination: "Hedef kaynakça",
    chooseDestination: "Bir kaynakça seçin…",
    copySelected: "Kopyala",
    moveSelected: "Taşı",
    copyComplete: "{count} alıntı kopyalandı. {skipped} yinelenen öğe atlandı.",
    moveComplete:
      "{count} alıntı taşındı. {skipped} yinelenen öğe kaynakta kaldı.",
    selectCitation: "{title} öğesini seç",
    moveUp: "Yukarı taşı",
    moveDown: "Aşağı taşı",
    deleteTitle: "Kaynağı sil",
    deleteConfirm: "Kaynak silinsin mi?",
    deleted: "Kaynak silindi",
    editTitle: "Kaynağı düzenle",
    close: "Kapat",
    copiedAll: "Tüm kaynaklar kopyalandı!",
    copiedAnnotated: "Açıklamalı kaynakça kopyalandı!",
    copiedBibtex: "BibTeX kopyalandı!",
    copiedBulleted: "Madde işaretli liste kopyalandı!",
    copiedNumbered: "Numaralı liste kopyalandı!",
    copiedHtml: "HTML parçası kopyalandı!",
    downloadedWord: "Word belgesi indirildi",
    downloadedRtf: "RTF dosyası indirildi",
    downloadedRis: "RIS dosyası indirildi",
    downloadedCsl: "CSL-JSON dosyası indirildi",
    downloadedAnnotated: "Açıklamalı kaynakça indirildi",
    copyFailed: "Panoya kopyalanamadı",
    shareCopied:
      "Bağlantı kopyalandı! Bağlantıya sahip olan herkes bu listeyi görüntüleyip içe aktarabilir.",
    shareFailed: "Paylaşım bağlantısı oluşturulamadı",
    regenerateFailed: "Kaynak yeniden oluşturulamadı",
    updateFailed: "Kaynak güncellenemedi",
    fieldAuthor: "Yazar",
    fieldTitle: "Başlık",
    fieldDate: "Tarih",
    fieldPublisher: "Yayıncı",
    fieldVolume: "Cilt",
    fieldIssue: "Sayı",
    fieldPages: "Sayfa(lar)",
    fieldUrl: "URL",
    fieldAccessed: "Erişim tarihi",
    fieldEditor: "Editör",
    fieldEvent: "Etkinlik yeri",
    noteLabel: "Bu kaynak hakkında not",
    noteEdit: "Bu notu düzenle",
    notePlaceholder:
      "Kaynağı özetleyin, değerlendirin ve çalışmanıza nasıl uyduğunu yazın…",
    noteRemoved: "Not kaldırıldı",
    noteSave: "Notu kaydet",
    noteCancel: "İptal",
    noteAdd: "Not ekle",
    noteWords: "{count} kelime",
    noteSaved: "Not kaydedildi ({count} kelime)",
    noteClickToEdit: "düzenlemek için tıklayın",
    inTextCopy: "Bu kaynağın metin içi göndermesini kopyala",
    inTextSelect: "Kopyalamak için aşağıdaki göndermeyi seçin.",
    inTextFailed: "Metin içi gönderme oluşturulamadı. Lütfen tekrar deneyin.",
    locator: "Konum",
    locatorType: "Konum türü",
    locatorPage: "Sayfa",
    locatorChapter: "Bölüm",
    locatorSection: "Kısım",
    locatorParagraph: "Paragraf",
    locatorLine: "Satır",
    locatorVerse: "Ayet",
    reformat: "Yeniden biçimlendir",
    reformatTitle: "Tüm kaynakları başka bir stilde yeniden biçimlendir",
    reformatHeading: "Her şeyi tek bir stilde yeniden biçimlendir",
    reformatChoose: "Bir stil seçin…",
    reformatFailed: "Yeniden biçimlendirme başarısız. Kaynakçanız değişmedi.",
    sortOrder: "Sıralama ölçütü",
    copyToClipboard: "Panoya kopyala",
    numberedList: "Numaralı liste",
    bulletedList: "Madde işaretli liste",
    htmlSnippet: "HTML parçası",
    copyWithAnnotations: "Açıklamalarla kopyala",
    wordAnnotated: "Açıklamalı Word belgesi (.doc)",
    downloadFile: "Dosyayı indir",
    wordDocument: "Word belgesi (.doc)",
    copyShareLink: "Paylaşım bağlantısını kopyala",
    print: "Yazdır…",
    printFailed: "Açılır pencere engellendi — yazdırmak için izin verin",
    font: "Yazı tipi",
    sitePublication: "Site / yayın adı",
    importIntro:
      "Bir BibTeX (.bib), RIS (.ris) veya CSL-JSON (.json) dosyası yapıştırın ya da yükleyin",
    importUpload: ".bib, .ris veya .json dosyası yükleyin",
    importPaste: "Ya da BibTeX, RIS veya CSL-JSON yapıştırın",
    cancel: "İptal",
    done: "Bitti",
    delete: "Sil",
    deleteBody: "Bu kaynak kaynakçanızdan kalıcı olarak kaldırılacak.",
    editBody: "Üst verileri güncelleyip kaydedin; kaynak yeniden oluşturulur.",
    reformatExplain:
      "{count} kaydın tamamını kayıtlı kaynak verilerinden yeniden oluşturur — hiçbir şey yeniden indirilmez ve hiçbir kaynak kaybolmaz.",
    inTextHeading: "Metin içi gönderme",
    inTextLocatorHint:
      "Göndermeyi kaynaktaki belirli bir yere bağlamak için sayfa ya da başka bir konum ekleyin — doğrudan alıntılarda çoğu stil bunu ister. Sade biçim için boş bırakın.",
    inTextCopyButton: "Metin içi göndermeyi kopyala",
    mixedStyles:
      "Bu kaynakça {count} farklı atıf stilini karıştırıyor ({styles}).",
    mixedStylesAction:
      "Teslim etmeden önce hepsini tek bir stile getirmek için {action} kullanın.",
    selectBibliography: "Kaynakça seç",
    newBibliography: "Yeni kaynakça",
    moreOptions: "Diğer seçenekler",
    rename: "Yeniden adlandır",
    removeDuplicates: "Yinelenenleri kaldır",
    cannotDeleteOnly: "Tek kaynakçanızı silemezsiniz",
    newBibliographyBody: "Başka bir ödev veya proje için kaynakça oluşturun.",
    bibliographyName: "Kaynakça adı",
    create: "Oluştur",
    renameBibliography: "Kaynakçayı yeniden adlandır",
    renameBibliographyBody: "“{name}” için yeni bir ad girin.",
    newName: "Yeni ad",
    duplicateRemovedOne: "{count} yinelenen kaldırıldı",
    duplicateRemovedMany: "{count} yinelenen kaldırıldı",
    noDuplicates: "Yinelenen kaynak bulunamadı",
    removeDuplicatesConfirm: "Yinelenen kaynaklar kaldırılsın mı?",
    removeDuplicatesBody:
      "“{name}” içinde aynı kaynaklar (DOI, ISBN veya başlık, yıl ve yazar ile) bulunur ve bir kopya tutulur. Eşleştirilemeyen kaynaklar değiştirilmez.",
    deleteBibliographyConfirm: "Kaynakça silinsin mi?",
    deleteBibliographyBody:
      "Bu işlem “{name}” kaynakçasını ve içindeki {count} atfı kalıcı olarak siler.",
  },

  bibliographyPage: {
    metaTitle:
      "Kaynakça Stüdyosu - atıfları düzenleyin, notlandırın ve dışa aktarın",
    metaDescription:
      "Tarayıcınızda özel kaynakça projeleri oluşturun. Hesap olmadan arayın, sıralayın, not ekleyin, düzenleyin, biçimlendirin, içe ve dışa aktarın.",
    keyword1: "kaynakça oluşturucu",
    keyword2: "atıf yöneticisi",
    keyword3: "açıklamalı kaynakça aracı",
    ogTitle: "Kaynakça Stüdyosu",
    ogDescription:
      "Atıfları düzenlemek, biçimlendirmek, notlandırmak, içe ve dışa aktarmak için özel bir çalışma alanı.",
    ogImageTitle: "Kaynakça Stüdyosu",
    ogImageSubtitle:
      "Kaynaklarınızı düzenleyin, notlandırın, biçimlendirin, aktarın ve paylaşın.",
    ogKind: "Atıf çalışma alanı",
    breadcrumb: "Kaynakça Stüdyosu",
    eyebrow: "Tarayıcı tabanlı özel çalışma alanı",
    lead: "Bir ödevin tüm kaynaklarını tek yerde yönetin. Siz dışa aktarmadıkça veya paylaşmadıkça projeler bu tarayıcıda kalır.",
    privacyTitle: "Varsayılan olarak özel",
    privacyBody:
      "Projeler ve notlar yerel tarayıcı depolamasını kullanır. Paylaşım bağlantıları atıfları içerir, özel notları ise özellikle dışarıda bırakır.",
    workflowTitle: "Kaynak listesinden son çalışmaya",
    workflowBody:
      "Projeler arasında geçin, kaynakları arayıp sıralayın, not veya konum ekleyin, üst verileri düzeltin ve tüm listeyi tek stilde biçimlendirin.",
    formatsTitle: "Kaynakları içe aktarın ve her yere taşıyın",
    formatsBody:
      "BibTeX, RIS veya CSL-JSON içe aktarın. Biçimlendirilmiş listeleri kopyalayın ya da Word, RTF, RIS, CSL-JSON, HTML, BibTeX ve notlu sürümleri dışa aktarın.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - tanım ve örnekler",
    notFoundTitle: "Terim bulunamadı",
    keywordDefinition: "{term} tanımı",
    keywordWhatIs: "{term} nedir",
    ogTitle: "{term} - CitationEasy sözlüğü",
    ogKind: "Kaynak gösterme sözlüğü",
    breadcrumb: "Sözlük",
    alsoCalled: "Ayrıca şu şekilde de bilinir: {aliases}",
    doItHeading: "CitationEasy'de yapın",
    seeAlsoHeading: "Ayrıca bakınız",
    moreInHeading: "{category} kategorisinde daha fazlası",
    navLabel: "Sözlük gezinmesi",
    allTermsLink: "Tüm {count} sözlük terimi",
    generatorLink: "Ücretsiz kaynakça oluşturucu",
    termSetName: "CitationEasy kaynak gösterme sözlüğü",
    hubMetaTitle: "Kaynak gösterme sözlüğü - {count} terim açıklandı",
    hubMetaDescription:
      "{count} kaynak gösterme ve akademik yazım teriminin sade tanımları: et al., ibid., DOI, asılı girinti, patchwriting, sürüm kaydı ve daha fazlası — her biri örnekleriyle.",
    hubKeyword1: "kaynak gösterme sözlüğü",
    hubKeyword2: "kaynak gösterme terimleri",
    hubKeyword3: "akademik yazım sözlüğü",
    hubKeyword4: "et al ne demek",
    hubKeyword5: "DOI nedir",
    hubKeyword6: "kaynak gösterme terminolojisi",
    hubOgTitle: "Kaynak gösterme sözlüğü",
    hubOgDescription:
      "{count} kaynak gösterme ve akademik yazım teriminin örnekli tanımları.",
    hubOgImageTitle: "Kaynak gösterme sözlüğü",
    hubOgImageSubtitle:
      "{count} kaynak gösterme ve akademik yazım terimi, örnekleriyle sade biçimde tanımlandı.",
    hubOgKind: "Başvuru kaynağı",
    hubTermSetDescription:
      "{count} kaynak gösterme, atıf ve akademik yazım teriminin tanımları.",
    hubCollectionName: "Kaynak gösterme sözlüğü",
    hubCollectionDescription:
      "{count} kaynak gösterme ve akademik yazım teriminin sade tanımları.",
    hubHeading: "Kaynak gösterme sözlüğü",
    hubIntro:
      "Kaynak gösterme ve akademik yazımdan {count} terim; örnekleriyle sade biçimde tanımlandı — stil rehberlerinde karşınıza çıkan kısaltmalar, bir kaynağın oluşturulduğu bileşenler, bir kaynağı kesin olarak belirleyen tanımlayıcılar ve akademik yayıncılığın kelime dağarcığı.",
    hubJumpLabel: "Harfe git",
    hubBrowseHeading: "Konuya göre göz atın",
    hubAllHeading: "Tüm terimler A–Z",
    hubWorkHeading: "Terimleri uygulamaya koyun",
    hubWorkGenerator: "Ücretsiz kaynakça oluşturucu",
    hubWorkStyles: "Atıf stili rehberleri",
    hubWorkHowTo: "Herhangi bir kaynak nasıl gösterilir",
    hubWorkCompare: "Atıf stillerini karşılaştır",
    hubWorkTools: "Yazma ve kaynak gösterme araçları",
    hubWorkFaq: "Kaynak gösterme SSS",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle: "Kaynak gösterme SSS - Sık sorulan sorulara hızlı yanıtlar",
    metaDescription:
      "Öğrencilerin gerçekten sorduğu kaynak gösterme sorularına hızlı, doğru yanıtlar: DOI'ler, yazarsız kaynaklar, et al., asılı girintiler, yapay zekaya atıf verme, intihal kuralları, APA ile MLA karşılaştırması ve daha fazlası — ayrıntılı rehberlere bağlantılarla birlikte.",
    ogTitle: "Kaynak gösterme SSS",
    ogDescription:
      "DOI'lerden ve et al.'den ChatGPT'ye atıf vermeye kadar en sık sorulan kaynak gösterme sorularına hızlı yanıtlar.",
    ogImageTitle: "Kaynak gösterme soruları ve yanıtları",
    ogImageSubtitle:
      "Öğrencilerin kaynak gösterme konusunda gerçekten sorduğu sorulara kısa, doğru yanıtlar.",
    ogKind: "SSS",
    breadcrumbLabel: "Gezinme yolu",
    breadcrumbHome: "Ana sayfa",
    breadcrumbCurrent: "Kaynak gösterme SSS",
    heading: "Kaynak gösterme SSS",
    intro:
      "Öğrencilerin gerçekten sorduğu kaynak gösterme sorularına hızlı, doğru yanıtlar — daha fazla ayrıntı gerektiğinde tam rehbere veya araca bağlantılarla birlikte.",
    contentsLabel: "SSS içeriği",
    stillStuckHeading: "Hâlâ takıldınız mı?",
    stillStuckBody:
      "[Tüm rehber kitaplığına](/guides) göz atın, [stil özet kılavuzlarını](/cheat-sheets) inceleyin, [kaynak gösterme sözlüğünden](/glossary) bir terime bakın, [tüm siteyi arayın](/search) ya da [kaynağı oluşturun](/) ve kuralları sizin için oluşturucunun uygulamasına izin verin.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle: "Atıf stili özet kılavuzları - Hızlı başvuru rehberleri",
    hubMetaDescription:
      "APA, MLA ve Chicago atıf stilleri için hızlı başvuru özet kılavuzları. Yaygın kaynak türü örnekleriyle yazdırmaya uygun rehberler.",
    hubBreadcrumbHome: "Ana sayfa",
    hubBreadcrumbCurrent: "Atıf stili özet kılavuzları",
    hubBackLink: "← Oluşturucuya dön",
    hubHeading: "Atıf stili özet kılavuzları",
    hubIntro:
      "En popüler atıf stilleri için hızlı başvuru rehberleri. Yazdırmaya uygun ve her zaman güncel.",
    hubApaTitle: "APA 7. Baskı özet kılavuzu",
    hubApaDesc: "Psikoloji, sosyal bilimler, eğitim, hemşirelik",
    hubMlaTitle: "MLA 9. Baskı özet kılavuzu",
    hubMlaDesc: "Edebiyat, diller, beşeri bilimler, kültürel çalışmalar",
    hubChicagoTitle: "Chicago stili özet kılavuzu",
    hubChicagoDesc: "Tarih, sanat tarihi, felsefe, din",
    backToSheets: "← Özet kılavuzlarına dön",
    generalRules: "Genel kurallar",
    inTextCitations: "Metin içi atıflar",
    colSituation: "Durum",
    colFormat: "Biçim",
    colExample: "Örnek",
    book: "Kitap",
    journalArticle: "Dergi makalesi",
    website: "Web sitesi",
    apaMetaTitle: "APA 7. Baskı özet kılavuzu - Hızlı başvuru rehberi",
    apaMetaDescription:
      "Kitaplar, dergiler, web siteleri ve daha fazlası için örnekli APA 7. baskı özet kılavuzu. Yazdırmaya uygun hızlı başvuru.",
    apaHeading: "APA 7. Baskı özet kılavuzu",
    apaLead: "En yaygın APA kaynak biçimleri için hızlı başvuru.",
    apaRule1:
      "**Asılı girinti** kullanın (ilk satır sola dayalı, sonraki satırlar 1,27 cm içeriden)",
    apaRule2: "Tüm girdilerde çift satır aralığı kullanın",
    apaRule3: "Yazarın soyadına göre alfabetik sıralayın",
    apaRule4: "Kitap, dergi ve cilt başlıklarını italik yapın",
    apaRule5: "Mevcut olduğunda DOI kullanın",
    apaRow1Situation: "1 yazar",
    apaRow1Format: "(Author, Year)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 yazar",
    apaRow2Format: "(Author & Author, Year)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3+ yazar",
    apaRow3Format: "(First Author et al., Year)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "Doğrudan alıntı",
    apaRow4Format: "(Author, Year, p. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "Yazar yok",
    apaRow5Format: '("Title," Year)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "Kaynakça örnekleri",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "Editörlü kitap bölümü",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "Konferans bildirisi",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "APA 6'dan temel farklar",
    apaDifference1: 'URL\'lerden önce "Retrieved from" ifadesi yok',
    apaDifference2: "DOI'yi https://doi.org/ bağlantı biçiminde belirtin",
    apaDifference3: "Üç nokta kullanmadan önce 20 yazara kadar listelenir",
    apaDifference4: "Yayıncının konumu artık gerekli değil",
    apaDifference5: 'Cinsiyetten bağımsız dil için tekil "they" kullanın',
    apaCtaText: "Mükemmel APA kaynaklarını otomatik oluşturun",
    apaCtaButton: "APA kaynakça oluşturucu →",
    mlaMetaTitle: "MLA 9. Baskı özet kılavuzu - Hızlı başvuru rehberi",
    mlaMetaDescription:
      "Kitaplar, makaleler, web siteleri ve daha fazlası için örnekli MLA 9. baskı özet kılavuzu. Yazdırmaya uygun hızlı başvuru.",
    mlaHeading: "MLA 9. Baskı özet kılavuzu",
    mlaLead: "En yaygın MLA kaynak biçimleri için hızlı başvuru.",
    mlaRule1: "**Asılı girinti** kullanın",
    mlaRule2: "Tüm girdilerde çift satır aralığı kullanın",
    mlaRule3: "Yazarın soyadına göre alfabetik sıralayın",
    mlaRule4: 'Sayfayı "Atıf yapılan eserler" olarak adlandırın',
    mlaRule5:
      "Kapsayıcıların başlıklarını italik yapın (kitaplar, dergiler, web siteleri)",
    mlaRow1Situation: "1 yazar",
    mlaRow1Format: "(Author Page)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 yazar",
    mlaRow2Format: "(Author and Author Page)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3+ yazar",
    mlaRow3Format: "(First Author et al. Page)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "Yazar yok",
    mlaRow4Format: '("Title" Page)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "Sayfa numarası yok",
    mlaRow5Format: "(Author)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "Atıf yapılan eserler örnekleri",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "Antoloji / editörlü kitap",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "MLA temel öğeleri (sırasıyla)",
    mlaCore1: "Yazar.",
    mlaCore2: '"Kaynağın başlığı."',
    mlaCore3: "*Kapsayıcının başlığı*,",
    mlaCore4: "Katkıda bulunanlar,",
    mlaCore5: "Sürüm,",
    mlaCore6: "Numara,",
    mlaCore7: "Yayıncı,",
    mlaCore8: "Yayın tarihi,",
    mlaCore9: "Konum (sayfalar, URL, DOI).",
    mlaCtaText: "Mükemmel MLA kaynaklarını otomatik oluşturun",
    mlaCtaButton: "MLA kaynakça oluşturucu →",
    chicagoMetaTitle: "Chicago stili özet kılavuzu - Hızlı başvuru rehberi",
    chicagoMetaDescription:
      "Notes-Bibliography ve Author-Date örnekleriyle Chicago Manual of Style özet kılavuzu. Yazdırmaya uygun hızlı başvuru.",
    chicagoHeading: "Chicago stili özet kılavuzu",
    chicagoLead:
      "Chicago Manual of Style (18. baskı) kaynak biçimleri için hızlı başvuru.",
    chicagoSystemsHeading: "İki Chicago sistemi",
    chicagoColNb: "Not-Bibliyografya (NB)",
    chicagoColAd: "Yazar-Tarih (AD)",
    chicagoRow1Nb: "Dipnotlar/sonnotlar + bibliyografya",
    chicagoRow1Ad: "Parantez içi atıflar + kaynakça",
    chicagoRow2Nb: "Tarih, sanat, beşeri bilimler",
    chicagoRow2Ad: "Fen bilimleri, sosyal bilimler",
    chicagoRow3Nb: "Daha ayrıntılı ilk notlar",
    chicagoRow3Ad: "APA biçimine benzer",
    chicagoExamplesHeading: "Not-Bibliyografya örnekleri",
    chicagoNoteLabel: "Not:",
    chicagoBibliographyLabel: "Bibliyografya:",
    chicagoBookLabel: "Kitap (dipnot)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "Dergi makalesi (dipnot)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "Web sitesi (dipnot)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "Kısaltılmış notlar",
    chicagoShortIntro: "İlk tam atıftan sonra kısaltılmış dipnotlar kullanın:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "Temel biçimlendirme kuralları",
    chicagoRule1:
      "Metindeki dipnot göndermeleri için üst simge rakamlar kullanın",
    chicagoRule2: "Bibliyografya girdileri asılı girinti kullanır",
    chicagoRule3:
      'Aynı kaynağa art arda yapılan atıflarda "Ibid." yerine kısaltılmış dipnot kullanın',
    chicagoRule4:
      "Başlıklar: kitaplar ve dergiler italik, makaleler ve bölümler tırnak içinde",
    chicagoRule5:
      "Değişebilecek çevrimiçi kaynaklar için erişim tarihlerini belirtin",
    chicagoCtaText: "Mükemmel Chicago kaynaklarını otomatik oluşturun",
    chicagoCtaButton: "Chicago kaynakça oluşturucu →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "Temel sayfalar",
    styleLanding: "Başlıca atıf stili sayfaları",
    style: "Atıf stili bilgi sayfaları",
    styleExamples: "Kaynak gösterimi örneği sayfaları",
    styleFormat: "Ödev biçimlendirme rehberleri",
    styleInText: "Metin içi atıf rehberleri",
    styleAnnotatedBibliography: "Açıklamalı kaynakça rehberleri",
    styleReferencePage: "Kaynakça / atıf yapılan eserler sayfası rehberleri",
    tool: "Ücretsiz yazma ve kaynak gösterme araçları",
    guide: "Eğitim rehberleri",
    guideCategory: "Rehber kategorileri",
    toolCollection: "Araç koleksiyonları",
    howToCite: "<kaynak>, <stil> stilinde nasıl gösterilir",
    comparison: "Atıf stili karşılaştırmaları",
    converter: "Tanımlayıcı ve biçim dönüştürücüleri",
    field: "Akademik alana göre atıf stilleri",
    region: "Ülkeye/bölgeye göre atıf stilleri",
    category: "Konu kategorisine göre atıf stilleri",
    cheatSheet: "Tek sayfalık özet kılavuzlar",
    glossary: "Kaynak gösterme ve akademik yazım sözlüğü",
  },

  // /about
  aboutPage: {
    metaTitle: "CitationEasy hakkında - ücretsiz kaynakça oluşturucu",
    metaDescription:
      "CitationEasy, {count} stili destekleyen ücretsiz bir kaynakça oluşturucudur. Citation Style Language, Citation.js ve Next.js gibi açık kaynaklı araçlar kullanılarak Samuel Sergi tarafından geliştirilmiştir.",
    backLink: "← Oluşturucuya dön",
    heading: "CitationEasy hakkında",
    intro:
      "CitationEasy; öğrenciler, araştırmacılar ve akademik yazarlar için geliştirilmiş ücretsiz, herkese açık bir kaynakça oluşturucudur. **{count} atıf stilini** destekler ve kayıt ya da abonelik gerektirmeden yazma araçlarından, eğitim rehberlerinden ve başvuru kaynaklarından oluşan, sürekli büyüyen bir koleksiyon sunar.",
    offerHeading: "Neler sunuyoruz",
    offer1:
      "APA 7, MLA 9, Chicago 18, Harvard, Vancouver, IEEE ve binlerce diğerini içeren {count} stille [kaynakça oluşturucu](/)",
    offer2:
      "[40 ücretsiz yazma ve kaynak gösterme aracı](/tools) — kelime sayacı, okunabilirlik denetleyicisi, DOI doğrulayıcı, kaynakça alfabe sıralayıcısı ve daha fazlası",
    offer3:
      '6 atıf stilinde her önemli kaynak türünü kapsayan [750 "nasıl kaynak gösterilir" rehberi](/how-to-cite)',
    offer4:
      "Kaynak gösterme en iyi uygulamaları, akademik yazım ve araştırma becerileri üzerine [100'den fazla eğitim rehberi](/guides)",
    offer5:
      "Hızlı başvuru için [stil karşılaştırma aracı](/compare), [atıf stili testi](/quiz) ve [özet kılavuzlar](/cheat-sheets)",
    offer6:
      "7 dışa aktarma biçimi: düz metin, BibTeX, Word, numaralı liste, madde işaretli liste, RIS ve CSV",
    openSourceHeading: "Açık kaynakla geliştirildi",
    openSourceIntro:
      "CitationEasy, sayısız mükemmel açık kaynaklı proje ve API sayesinde mümkün oldu. Emeğin karşılığını vermeye inanıyoruz:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — {count} atıf stilimizi çalıştıran açık standart. CSL, bir gönüllü topluluğu tarafından sürdürülür ve Zotero, Mendeley ve Papers gibi kaynakça yöneticileri tarafından kullanılır. Stil tanımları GitHub'daki [CSL Styles deposundan](https://github.com/citation-style-language/styles) alınır.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — kaynakları işleyip CSL stillerine göre biçimlendiren JavaScript kitaplığı. Lars Willighagen tarafından oluşturulmuştur.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — Internet Archive tarafından sağlanan, başlık veya ISBN ile kitap üst verisi aramak için kullanılan ücretsiz kitap arama API'si.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — DOI'leri çözümlemek ve doğrulamak için kullanılan Digital Object Identifier sistemi.",
    createdHeading: "Kim oluşturdu",
    createdBody:
      "CitationEasy, **Samuel Sergi** tarafından oluşturulmuş ve sürdürülmektedir. Amaç basit: özellikleri ödeme duvarlarının arkasına gizlemeyen veya hesap gerektirmeyen, gerçekten ücretsiz, yüksek kaliteli bir kaynak gösterme aracı sunmak.",
    contactPrompt:
      "Sorularınız, geri bildiriminiz veya önerileriniz mi var? Bize ulaşın:",
    contactEmail: "E-posta: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "Misyonumuz",
    mission1:
      "Doğru kaynak gösterme para karşılığı olmamalı. Birçok kaynak gösterme aracı kendini ücretsiz olarak tanıtır ama dışa aktarma biçimlerini kısıtlar, kaynak sayısını sınırlar veya kullanıcıları premium planlara yönlendirir. CitationEasy tamamen ücretsiz olmaya kararlıdır — kayıt yok, sınır yok, premium katman yok.",
    mission2:
      "Kaynakça oluşturucudan yazma araçlarına ve eğitim rehberlerine kadar bu sitedeki her özellik herkese ücretsiz olarak sunulur. Akademik dürüstlük araçlarının, bütçelerinden bağımsız olarak tüm öğrenciler ve araştırmacılar için erişilebilir olması gerektiğine inanıyoruz.",
  },

  // /contact
  contactPage: {
    metaTitle: "İletişim",
    metaDescription:
      "CitationEasy ile iletişime geçin. Ücretsiz kaynakça oluşturucumuz ve yazma araçlarımız hakkında sorularınız, geri bildiriminiz veya önerileriniz mi var? Sizden haber almak isteriz.",
    backLink: "← Oluşturucuya dön",
    heading: "İletişim",
    intro:
      "CitationEasy hakkında sorularınız, geri bildiriminiz veya önerileriniz mi var? Sizden haber almak isteriz. Bir hata bulduysanız, bir özellik talebiniz varsa veya bir kaynak gösterme konusunda yardıma ihtiyacınız varsa, bize ulaşmaktan çekinmeyin.",
    touchHeading: "Bize ulaşın",
    touchBody:
      "Bize ulaşmanın en iyi yolu e-postadır. 48 saat içinde yanıt vermeyi hedefliyoruz.",
    emailLine: "**E-posta:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "Sık sorulan sorular",
    commonIntro:
      "Bize ulaşmadan önce, sorunuzun yanıtını şu kaynaklardan birinde bulabilirsiniz:",
    resource1:
      "[Kaynak gösterme rehberleri](/guides) — her önemli stilde kaynak göstermek için adım adım talimatlar",
    resource2:
      '["Nasıl kaynak gösterilir" rehberleri](/how-to-cite) — örnekleriyle birlikte 750 kaynak türü ve stil kombinasyonu',
    resource3:
      "[Özet kılavuzlar](/cheat-sheets) — APA, MLA ve Chicago biçimlendirmesi için hızlı başvuru",
    resource4:
      "[Yazma araçları](/tools) — kelime sayacı, okunabilirlik denetleyicisi, DOI doğrulayıcı ve daha fazlası",
    issueHeading: "Sorun bildirin",
    issueIntro:
      "Bir kaynak gösterme biçimlendirme hatası, bozuk bir özellik veya yanlış bir stil bulduysanız, bizimle iletişime geçerken lütfen mümkün olduğunca fazla ayrıntı ekleyin:",
    issue1: "Kullandığınız atıf stili",
    issue2: "Kaynak türü (kitap, web sitesi, dergi makalesi vb.)",
    issue3: "Beklediğiniz sonuç ile oluşturulan sonuç arasındaki fark",
    issue4: "Tarayıcınız ve cihazınız (ilgiliyse)",
    issueOutro: "Bu, sorunu hızlıca tespit edip düzeltmemize yardımcı olur.",
    aboutHeading: "CitationEasy hakkında",
    aboutBody:
      "CitationEasy, 10.000'den fazla atıf stilini destekleyen ücretsiz bir kaynakça oluşturucudur. Doğru kaynak göstermeyi herkes için erişilebilir kılma amacıyla Samuel Sergi tarafından oluşturulmuştur. [Hakkımızda sayfasında](/about) daha fazla bilgi edinin.",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "Yapay Zeka Asistanları ve Ajanları için CitationEasy - API, MCP Sunucusu, llms.txt",
    metaDescription:
      "CitationEasy'yi programatik olarak kullanın: {count} stilde kaynak gösterme için ücretsiz, kimlik doğrulama gerektirmeyen bir JSON API, ajanlar için bir MCP sunucusu, llms.txt, bir OpenAPI spesifikasyonu ve her sayfanın markdown görünümleri.",
    keyword1: "kaynak gösterme API'si",
    keyword2: "MCP sunucusu",
    keyword3: "kaynakça oluşturucu API'si",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "yapay zeka ajanı kaynak gösterme",
    keyword7: "ücretsiz kaynak gösterme API'si",
    webApiDescription:
      "Bir URL, DOI, ISBN, PubMed kimliği, arXiv kimliği veya CSL-JSON üst verisinden {count} Citation Style Language stilinde kaynak biçimlendiren ücretsiz, kimlik doğrulama gerektirmeyen JSON API.",
    breadcrumb: "Yapay zeka ve ajanlar için",
    heading: "Yapay zeka asistanları ve ajanları için CitationEasy",
    intro:
      "Bu sitedeki her şey, insanlar kadar yazılımlar için de kullanılabilir: ücretsiz bir JSON API, bir MCP sunucusu, bir OpenAPI spesifikasyonu, bir llms.txt dizini ve tüm {count} sayfanın markdown görünümü. Anahtar yok, hesap yok, kendi hız sınırımız yok.",
    whyHeading: "Kaynağı kendiniz yazmak yerine neden API'yi çağırmalısınız",
    whyBody:
      "Kaynak biçimlendirme bir metin üretme problemi gibi görünür ama değildir. Her stil; yazar adı ters çevirme, baş harfler, başlık büyük/küçük harf kullanımı, kapsayıcı noktalama, baskı bilgisi ve tarih yerleşimiyle ilgili yüzlerce kural kodlar ve bunlar, ezberden yapıldığında ince şekillerde yanlış gidilmesi kolay biçimlerde farklılık gösterir. CitationEasy, resmî Citation Style Language tanımlarına karşı **citeproc-js**'i çalıştırır — Zotero ve Mendeley'in kullandığı aynı motor — böylece çıktı deterministiktir ve bir derginin gönderim sisteminin beklediğiyle eşleşir. Üst veriler Crossref, Open Library ve PubMed'den gelir; hiçbir şey uydurulmaz ve kaynağında eksik olan bir alan, olası bir tahminle doldurulmak yerine eksik kalır.",
    generateHeading: "Bir kaynak oluşturun",
    generateBody:
      "Tek çağrıda 10'a kadar kaynak için `input` yerine `inputs` gönderin ya da aramayı tamamen atlamak için zaten elinizde olan CSL-JSON üst verisiyle `entry` gönderin. Dipnot biçimi için `note: true` ekleyin. Kaynak başına oluşan hatalar o kaynakla birlikte döner, bu yüzden bir toplu işlem asla bütün olarak başarısız olmaz.",
    mcpHeading: "MCP üzerinden bağlanın",
    mcpIntro:
      "`/api/mcp` adresindeki Model Context Protocol uç noktası, streamable HTTP üzerinden JSON-RPC 2.0 konuşur ve kimlik bilgisi gerektirmez.",
    mcpToolsHeading: "Sunduğu araçlar",
    endpointsHeading: "Uç noktalar",
    colEndpoint: "Uç nokta",
    colWhat: "Ne yapar",
    endpointCite:
      "Aynı anda 10'a kadar kaynağı biçimlendirir. Bir URL, DOI, ISBN, PubMed kimliği, arXiv kimliği, BibTeX/RIS/CSL-JSON metni veya bir CSL-JSON girdi nesnesi alır. Kaynakça girdisini ve isteğe bağlı olarak metin içi atfı ve dipnotu döndürür.",
    endpointStyles:
      "Tüm {count} stili ada, kaynak biçimi sınıfına, disipline veya bölgeye göre arar.",
    endpointStyleSlug:
      "Kendi CSL tanımıyla üretilmiş gerçek biçimlendirilmiş örneklerle birlikte tam olarak bir stil.",
    endpointSearch:
      "Sitedeki tüm sayfalarda alaka düzeyine göre sıralanmış arama.",
    endpointPages:
      "Sayfa türüne göre filtrelenebilen, yapılandırılmış girdiler halinde eksiksiz site kataloğu.",
    endpointHowToCite:
      "Her ikisine göre de filtrelenebilen, her kaynak türü × stil rehberlik sayfası.",
    endpointTools:
      "Kategorisi ve anahtar kelimeleriyle birlikte her ücretsiz araç.",
    endpointGuides: "Kategorisiyle birlikte her eğitim rehberi.",
    endpointConverters:
      "Sitenin sunduğu her tanımlayıcı ve biçim dönüştürmesi.",
    endpointComparisons:
      "Her iki stilin kayıtlarına bağlanan, yan yana stil karşılaştırmaları.",
    endpointFields:
      'Akademik alanlar, konu kategorileri ve bölgeler — "hangi stili kullanmalıyım?" sorusunu yanıtlamak için.',
    endpointFaq:
      "q ile filtrelenebilen, yaygın kaynak gösterme sorularına doğrulanmış yanıtlar.",
    endpointGlossary:
      "Tam tanımlarıyla birlikte kaynak gösterme ve akademik yazım terimleri — yanıt metni taşır, bu yüzden sonrasında getirilecek bir sayfa yoktur.",
    endpointIndex: "Uç nokta keşif belgesi. Keşfediyorsanız buradan başlayın.",
    discoveryHeading: "Keşif dosyaları",
    discoveryLlms: "Dil modelleri için yazılmış, derlenmiş site dizini.",
    discoveryLlmsFull:
      "Sitenin yayınladığı, türe göre gruplandırılmış, her biri tek satır halindeki tüm sayfalar.",
    discoveryOpenapi: "Tüm herkese açık API'nin OpenAPI 3.1 tanımı.",
    discoveryMcp:
      "MCP uç noktası (streamable HTTP). Bir açıklama için tarayıcıda GET isteği yapın.",
    discoveryWellKnownMcp:
      "Bir alan adını sorgulayan ajanlar için MCP keşif belgesi.",
    discoveryAiPlugin:
      "Hâlâ bir tane arayan çerçeveler için eski eklenti bildirimi.",
    discoveryMd: "Sitedeki herhangi bir sayfanın markdown görünümü.",
    discoverySitemap: "Dizine eklenebilen her URL.",
    catalogHeading: "Katalogda neler var",
    catalogIntro:
      "Aşağıdaki her sayfaya HTML olarak, `/md/` altında markdown olarak ve `/api/v1/pages`'ten yapılandırılmış bir girdi olarak ulaşılabilir.",
    catalogStyles:
      "Her biri kendi CSL tanımından üretilmiş gerçek örneklere sahip **{count}** atıf stili",
    catalogTools: "**{count}** ücretsiz tarayıcı aracı",
    catalogGuides: "**{count}** eğitim rehberi",
    catalogHowToCite: '**{count}** "nasıl kaynak gösterilir" sayfası',
    catalogComparisons: "**{count}** stil karşılaştırması",
    catalogConverters: "**{count}** dönüştürücü",
    catalogFields: "**{count}** akademik alan",
    catalogStyleLandings:
      "Tam biçimlendirme kurallarına sahip **{count}** başlıca stil sayfası",
    faqHeading: "Sık sorulan sorular",
    faqFreeQ:
      "CitationEasy API'si ücretsiz mi ve bir API anahtarına ihtiyacım var mı?",
    faqFreeA:
      "Ücretsizdir ve bir API anahtarı yoktur. /api/v1 altındaki her uç nokta kimlik doğrulama gerektirmez ve CORS'a açıktır, bu yüzden onu bir tarayıcıdan, bir not defterinden veya bir ajandan kayıt olmadan çağırabilirsiniz. Kendi hız sınırımız yoktur, ancak tanımlayıcı aramaları kendi adil kullanım sınırlarını uygulayan Crossref, Open Library ve PubMed üzerinden vekil olarak yapılır — birçok paralel istek göndermek yerine `inputs` ile toplu işlem yapın.",
    faqLlmQ: "Kaynaklar bir dil modeli tarafından mı üretiliyor?",
    faqLlmA:
      "Hayır. Biçimlendirme, kaynakça yöneticilerinin kullandığı aynı motor olan resmî Citation Style Language tanımlarına karşı citeproc-js'i çalıştırır. Aynı girdi ve stil her zaman aynı dizeyi üretir. Bibliyografik üst veriler Crossref'ten (DOI'ler), Open Library'den (ISBN'ler) ve PubMed'den (PMID'ler) gelir — CitationEasy alan uydurmaz, bu yüzden kaynağında eksik olan her şey, tahmin edilmek yerine çıktıda da eksik kalır.",
    faqMcpQ: "Bir ajanı MCP üzerinden CitationEasy'ye nasıl bağlarım?",
    faqMcpA:
      "Herhangi bir Model Context Protocol istemcisini, streamable HTTP taşımasını kullanarak https://www.citationeasy.com/api/mcp adresine yönlendirin. Herhangi bir kimlik bilgisi gerekmez. Claude Code'da: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. Sunucu; kaynak oluşturma, {count} stilde arama yapma, kaynak türü rehberliği, site araması ve herhangi bir sayfayı markdown olarak okuma için araçlar sunar.",
    faqStylesQ: "API hangi atıf stillerini üretebilir?",
    faqStylesA:
      'APA 7, MLA 9, her iki Chicago sistemi, Harvard, Vancouver, IEEE, AMA ve binlerce bireysel dergi stili dahil olmak üzere Citation Style Language deposundaki tüm {count} stil. Stil slug\'ını `style` alanında iletin. "chicago" ve "harvard" gibi kullanıcı dostu slug\'lar doğru CSL varyantına çözümlenir, gerisini ise /api/v1/styles?q= bulur.',
    faqLlmsTxtQ: "llms.txt nedir ve CitationEasy'ninki nerede?",
    faqLlmsTxtA:
      "llms.txt, tarayıcılar yerine dil modelleri için yazılmış düz metin bir site dizinidir. CitationEasy'ninki /llms.txt adresindedir; sitenin her sayfasını listeleyen eksiksiz sürüm ise /llms-full.txt adresindedir.",
    faqMarkdownQ:
      "CitationEasy sayfalarını HTML yerine markdown olarak okuyabilir miyim?",
    faqMarkdownA:
      "Evet. Herhangi bir site yoluna /md/ önekini ekleyin — örneğin /md/citation-style/apa veya /md/tools/word-counter. Veri odaklı sayfalar, her stilin kendi CSL tanımından üretilen gerçek biçimlendirilmiş örnekler dahil tam içeriklerini döndürür. Elle yazılmış düzyazı sayfaları (rehberler, özet kılavuzlar), metinleri sayfanın kendisinde yaşadığı için bir özet kartı ile birlikte kanonik HTML URL'sini döndürür.",
    faqReuseQ: "CitationEasy çıktısını kendi ürünümde kullanabilir miyim?",
    faqReuseA:
      "Evet. Biçimlendirilmiş bir kaynak, bir kaynak hakkındaki bir gerçektir; onu özgürce kullanın. CSL stil tanımlarının kendisi, CC BY-SA 3.0 lisansı altında Citation Style Language projesinden gelir. CitationEasy'ye atıfta bulunmak takdir edilir ama zorunlu değildir.",
    missingHeading: "Eksik bir şey mi var?",
    missingBody:
      "Ajanınızın burada olmayan bir uç noktaya, alana veya biçime ihtiyacı varsa [bize bildirin](/contact). Elle mi göz atıyorsunuz? [Kaynakça oluşturucudan başlayın](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "Hangi atıf stilini kullanmalıyım? - Ücretsiz stil testi",
    metaDescription:
      "Ödeviniz için en uygun atıf stilini bulmak üzere alanınız, ödev türünüz ve tercihlerinizle ilgili birkaç hızlı soruyu yanıtlayın. APA, MLA, Chicago, Vancouver ve daha fazlası.",
    ogTitle: "Hangi atıf stilini kullanmalıyım?",
    ogDescription:
      "Ödeviniz için en uygun atıf stilini bulmak üzere ücretsiz testimizi çözün.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "Stil testi",
    backLink: "← Oluşturucuya dön",
    heading: "Hangi atıf stilini kullanmalıyım?",
    intro:
      "Birkaç hızlı soruyu yanıtlayın, ödeviniz için en uygun atıf stilini önerelim.",
    progress: "Soru {current} / {total}",
    qDiscipline: "Çalışma alanınız nedir?",
    optSocialScience: "Psikoloji / sosyal bilimler",
    optHumanities: "Edebiyat / beşeri bilimler",
    optHistory: "Tarih / sanat tarihi",
    optMedical: "Tıp / hemşirelik / sağlık",
    optEngineering: "Mühendislik / bilgisayar bilimi",
    optNaturalScience: "Fen bilimleri (biyoloji, kimya)",
    optLaw: "Hukuk",
    optBusiness: "İşletme / ekonomi",
    qPaperType: "Ne tür bir ödev yazıyorsunuz?",
    optResearch: "Araştırma ödevi veya tez",
    optReview: "Literatür taraması",
    optReport: "Laboratuvar raporu veya teknik rapor",
    optEssay: "Deneme veya ders ödevi",
    optJournal: "Dergi makalesi gönderimi",
    qRegion: "Kurumunuz nerede bulunuyor?",
    optUs: "Amerika Birleşik Devletleri",
    optUk: "Birleşik Krallık / Avustralya",
    optCanada: "Kanada",
    optEurope: "Avrupa (Birleşik Krallık hariç)",
    optOther: "Diğer",
    qPreference: "Atıf biçimi konusunda bir tercihiniz var mı?",
    optAuthorDate: "Metin içi atıflar (Yazar, Yıl)",
    optNumeric: "Numaralı kaynaklar [1]",
    optFootnotes: "Dipnotlar",
    optNoPreference: "Tercihim yok",
    styleVancouver: "Vancouver",
    styleAma: "AMA (American Medical Association)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (Council of Science Editors)",
    styleChicagoNotes: "Chicago (Notes & Bibliography)",
    styleMla: "MLA (9. Baskı)",
    styleApa: "APA (7. Baskı)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver, numaralı kaynaklar kullanan tıp ve sağlık bilimleri dergilerinin standardıdır.",
    reasonAma:
      "AMA, tıp dergilerinde yaygın olarak kullanılır ve numaralı atıflar içerir.",
    reasonIeee:
      "IEEE, mühendislik, bilgisayar bilimi ve BT alanlarının standart atıf stilidir.",
    reasonBluebook:
      "Bluebook, hukuki yazım için başvurulan kesin atıf stilidir. Chicago stili en yakın genel amaçlı alternatiftir.",
    reasonCse: "CSE, biyoloji ve fen bilimlerinin standardıdır.",
    reasonChicagoHistory:
      "Chicago (Notes & Bibliography), dipnot kullanan atıflarıyla tarih ve sanat tarihinin altın standardıdır.",
    reasonChicagoHumanities:
      "Chicago (Notes & Bibliography), dipnot tabanlı yaklaşımıyla beşeri bilimler için iyi çalışır.",
    reasonMla:
      "MLA, edebiyat, diller ve beşeri bilimler alanlarının standardıdır.",
    reasonApaBusiness:
      "APA, işletme, ekonomi ve yönetim alanlarında yaygın olarak kullanılır.",
    reasonHarvard:
      "Harvard kaynak gösterme sistemi, Birleşik Krallık ve Avustralya üniversitelerinde en yaygın kullanılan stildir.",
    reasonChicagoFootnotes:
      "Chicago (Notes & Bibliography), ayrıntılı atıflar için ideal olan dipnotları kullanır.",
    reasonVancouverNumeric:
      "Vancouver, metninizi sade ve okunabilir tutan numaralı atıflar kullanır.",
    reasonApaDefault:
      "APA; sosyal bilimler, eğitim ve birçok başka alanda en yaygın kullanılan atıf stilidir.",
    recommendLabel: "Önerimiz",
    generateButton: "{style} kaynakları oluştur",
    retakeButton: "Testi tekrar çöz",
    guidesLink:
      "Daha fazla yardım için kaynak gösterme rehberlerimize göz atın →",
    previousButton: "← Önceki soru",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "CitationEasy'de ara",
    metaDescription:
      "CitationEasy'deki tüm sayfaları aynı anda arayın: {count} atıf stili, 250'den fazla ücretsiz araç, rehberler, nasıl kaynak gösterilir sayfaları, stil karşılaştırmaları, dönüştürücüler ve sözlük.",
    keyword1: "atıf stillerinde ara",
    keyword2: "kaynak gösterme rehberi bul",
    keyword3: "kaynak gösterme aracı araması",
    ogDescription:
      "Sitedeki tüm sayfaları aynı anda arayın — stiller, araçlar, rehberler, nasıl kaynak gösterilir sayfaları, karşılaştırmalar, dönüştürücüler ve sözlük terimleri.",
    ogImageSubtitle:
      "Her atıf stili, araç, rehber, nasıl yapılır sayfası, karşılaştırma, dönüştürücü ve sözlük terimi — birlikte aranır.",
    ogKind: "Arama",
    breadcrumb: "Ara",
    heading: "CitationEasy'de ara",
    intro:
      "Sitedeki her atıf stili, araç, rehber, nasıl yapılır sayfası, karşılaştırma, dönüştürücü ve sözlük terimi — birlikte aranır.",
    inputLabel: "Arama sorgusu",
    inputPlaceholder:
      "örneğin: APA'da podcast kaynak gösterme, asılı girinti, DOI",
    submit: "Ara",
    browseHeading: "Ya da bölüme göre göz atın",
    browseStyles: "Atıf stilleri",
    browseStylesNote: "{count} stil",
    browseTools: "Ücretsiz araçlar",
    browseToolsNote: "{count} araç",
    browseHowTo: "Herhangi bir kaynak nasıl gösterilir",
    browseHowToNote: "{count} sayfa",
    browseGuides: "Rehberler",
    browseGuidesNote: "{count} rehber",
    browseGlossary: "Sözlük",
    browseGlossaryNote: "{count} terim",
    browseComparisons: "Stil karşılaştırmaları",
    browseComparisonsNote: "{count} karşılaştırma",
    browseConverters: "Dönüştürücüler",
    browseConvertersNote: "{count} dönüştürücü",
    browseCheatSheets: "Özet kılavuzlar",
    browseCheatSheetsNote: "{count} kılavuz",
    facetsLabel: "Sayfa türüne göre filtrele",
    facetAll: "Tümü ({count})",
    noMatches: '"{query}" ile eşleşen sayfa bulunamadı.',
    matchesOne: '"{query}" ile eşleşen {count} sayfa.',
    matchesMany: '"{query}" ile eşleşen {count} sayfa.',
    pagerLabel: "Sonuç sayfaları",
    pagerPrevious: "← Önceki",
    pagerNext: "Sonraki →",
    pagerPosition: "Sayfa {page} / {total}",
    paletteLoading: "Aranıyor…",
    paletteError: "Arama şu anda kullanılamıyor. Lütfen tekrar deneyin.",
    paletteViewAll: "“{query}” için tüm sonuçları görüntüle",
    apiNote:
      "Bir şeyler mi geliştiriyorsunuz? Aynı dizin, [/api/v1/search](/api/v1/search?q=podcast) adresinde JSON olarak ve MCP üzerinden de kullanılabilir — bkz. [ajan belgeleri](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "Bu Sayfayı Kaynak Göster - Tek Tıkla Kaynak Gösterme (Yer İmi Aracı ve Chrome Uzantısı)",
    metaDescription:
      'Herhangi bir web sayfasını tek tıkla kaynak gösterin. Ücretsiz "Bu Sayfayı Kaynak Göster" yer imi aracını yer imleri çubuğunuza sürükleyin ya da araç çubuğu düğmesi ve sağ tık ile kaynak gösterme özellikli ücretsiz Chrome uzantısını yükleyin. Chromebook\'larda ve kısıtlı tarayıcılarda da çalışır.',
    ogTitle:
      '"Bu Sayfayı Kaynak Göster" Yer İmi Aracı ve Chrome Uzantısı - CitationEasy',
    ogDescription:
      "Herhangi bir sayfadan tek tıkla web sitesi kaynak gösterme — sürükle-bırak bir yer imi aracı ve sağ tıkla kaynak gösteren ücretsiz bir Chrome uzantısı.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: '"Bu Sayfayı Kaynak Göster" Yer İmi Aracı',
    appName: '"Bu Sayfayı Kaynak Göster" Yer İmi Aracı',
    appDescription:
      "Okuduğunuz web sayfasını tek tıkla kaynak gösteren ücretsiz bir yer imi aracı — CitationEasy'yi sayfanın URL'si önceden doldurulmuş şekilde açar, ardından kaynağı APA, MLA, Chicago ve {count} stil daha ile biçimlendirir.",
    breadcrumbLabel: "Gezinme yolu",
    breadcrumbHome: "Ana sayfa",
    breadcrumbCurrent: '"Bu Sayfayı Kaynak Göster" Yer İmi Aracı',
    heading: "Bu sayfayı kaynak göster: Yer imi aracı ve Chrome uzantısı",
    intro:
      "Herhangi bir web sayfasını tek tıkla kaynak gösterin — üyelik gerekmez. Aşağıdaki yer imi aracını yer imleri çubuğunuza sürükleyin (hiçbir kurulum gerekmez) ya da araç çubuğu düğmesi ve sağ tıkla kaynak gösterme için ücretsiz Chrome uzantısını edinin.",
    dragPrompt: "Bu düğmeyi yer imleri çubuğunuza sürükleyin:",
    buttonTitle: "Beni yer imleri çubuğunuza sürükleyin",
    buttonLabel: "📑 Bu Sayfayı Kaynak Göster",
    dontClick:
      "Buradan tıklamayın — önce yukarıdaki yer imleri çubuğunuza sürükleyin.",
    installHeading: "Nasıl kurulur",
    step1Title: "Yer imleri çubuğunuzu gösterin",
    step1Body:
      "Çoğu tarayıcıda, düğmeyi bırakabileceğiniz bir yer olması için yer imleri çubuğunu açıp kapatmak üzere Ctrl+Shift+B (Mac'te Cmd+Shift+B) tuşlarına basın.",
    step2Title: "Düğmeyi yukarı sürükleyin",
    step2Body:
      'Aşağıdaki "Bu Sayfayı Kaynak Göster" düğmesine tıklayıp basılı tutun, ardından yer imleri çubuğunuza sürükleyip bırakın. Normal bir yer imine dönüşür.',
    step3Title: "Herhangi bir sayfada tıklayın",
    step3Body:
      "Bir makale, haber veya dergi sayfası okurken yeni yer iminize tıklayın. CitationEasy, o sayfanın URL'si önceden doldurulmuş ve kaynak kopyalamaya hazır şekilde açılır.",
    manualHeading: "Sürükleyemiyor musunuz? Elle ekleyin",
    manualBody:
      'Yeni bir yer imi oluşturun, adını "Bu Sayfayı Kaynak Göster" yapın ve şunu URL/adres olarak yapıştırın:',
    howHeading: "Nasıl çalışır",
    howBody:
      "Yer imi aracı, okuduğunuz sayfada herhangi bir kod çalıştırmaz. Yalnızca o sayfanın web adresini CitationEasy'ye iletir; sunucumuz orada herkese açık sayfa üst verilerini alır ve ayrıştırır — tıpkı URL'yi elle oluşturucuya yapıştırdığınızda izlenen güvenilir yol gibi. Bu, aracı güvenli tutar ve eski sayfa içi yer imi araçlarını devre dışı bırakan kaynaklar arası (cross-origin) sınırlamalardan kaçınır.",
    extensionHeading: "Chrome uzantısını mı tercih edersiniz?",
    extensionBody:
      "Ücretsiz CitationEasy uzantısı, geçerli sekmeyi kaynak gösteren bir araç çubuğu düğmesi ve bir bağlantıyı — ya da seçili bir DOI veya ISBN'i — açmadan kaynak göstermek için sağ tık seçenekleri ekler. Yer imi aracı gibi, ziyaret ettiğiniz sayfalarda hiçbir kod çalıştırmaz: yalnızca URL'yi CitationEasy'ye iletir. Yalnızca `activeTab` ve `contextMenus` izinlerine ihtiyaç duyar ve Chrome, Edge, Brave ve diğer Chromium tabanlı tarayıcılarda çalışır.",
    downloadButton: "⬇ Chrome uzantısını indirin (.zip)",
    install1: "Uzantıyı indirin ve arşivden çıkarın.",
    install2:
      "`chrome://extensions` adresini açın ve **Geliştirici modunu** açın (sağ üst).",
    install3:
      "**Paketlenmemiş öğe yükle**'ye tıklayın ve arşivden çıkarılan klasörü seçin.",
    install4:
      "CitationEasy düğmesini sabitleyin, ardından kaynak göstermek için herhangi bir sayfada ona tıklayın.",
    faqHeading: "Sık sorulan sorular",
    faqWhatQ: '"Bu Sayfayı Kaynak Göster" yer imi aracı nedir?',
    faqWhatA:
      "Tarayıcınızın yer imleri çubuğuna sürüklediğiniz küçük bir yer imidir. Herhangi bir web sayfasında ona tıkladığınızda, CitationEasy'yi o sayfanın URL'si zaten doldurulmuş şekilde yeni bir sekmede açar; böylece tek tıkla biçimlendirilmiş bir kaynak elde edersiniz — kopyala-yapıştıra gerek kalmaz.",
    faqExtensionNeededQ: "Bir uzantı kurmam gerekir mi?",
    faqExtensionNeededA:
      "Hayır. Yer imi aracı yalnızca bir yer imidir, bu yüzden kurulacak hiçbir şey ve verilecek hiçbir izin yoktur. Kısıtlı okul Chromebook'larında ve uzantıların engellendiği çoğu mobil tarayıcıda çalışır. Bir uzantı tercih ederseniz, bu sayfada ücretsiz bir Chrome uzantısı da mevcuttur.",
    faqChromeQ: "Bir Chrome uzantısı var mı?",
    faqChromeA:
      "Evet. Ücretsiz CitationEasy Chrome uzantısı, geçerli sekmeyi kaynak gösteren bir araç çubuğu düğmesi ile bir bağlantıyı veya seçili bir DOI/ISBN'i açmadan kaynak göstermek için sağ tık seçenekleri ekler. Ziyaret ettiğiniz sayfalarda hiçbir kod çalıştırmaz ve yalnızca activeTab ve contextMenus izinlerine ihtiyaç duyar. Bu sayfadan indirip chrome://extensions üzerinden yükleyin; Chrome, Edge, Brave ve diğer Chromium tabanlı tarayıcılarda çalışır.",
    faqAddQ: "Yer imi aracını nasıl eklerim?",
    faqAddA:
      'Yer imleri çubuğunuzun görünür olduğundan emin olun, ardından bu sayfadaki "Bu Sayfayı Kaynak Göster" düğmesini oraya sürükleyin. Sürükleme mümkün değilse (örneğin mobilde), elle yeni bir yer imi oluşturun ve yer imi aracı kodunu URL olarak yapıştırın.',
    faqSafeQ: "Güvenli mi? Bulunduğum sayfayı okuyor mu?",
    faqSafeA:
      "Evet, güvenlidir. Yer imi aracı, okuduğunuz sayfada hiçbir kod çalıştırmaz — yalnızca o sayfanın web adresini CitationEasy'ye gönderir; sunucumuz orada herkese açık sayfa üst verilerini alır ve ayrıştırır, tıpkı bir URL'yi elle yapıştırdığınızda olduğu gibi.",
    faqOtherSourcesQ: "Web siteleri dışındaki kaynaklar için de çalışır mı?",
    faqOtherSourcesA:
      'Yer imi aracı web sayfaları içindir, ancak altyapıdaki bağlantı ?source= parametresi aracılığıyla bir DOI, ISBN, PMID veya arXiv kimliğini de kabul eder — böylece paylaşılabilir bir "bunu kaynak göster" bağlantısı dergi makaleleri ve kitaplar için de çalışır.',
    relatedHeading: "İlgili araçlar",
    relatedGenerator: "Kaynakça oluşturucu",
    relatedHowToCite: "Bir web sitesi nasıl kaynak gösterilir",
    relatedTools: "Tüm araçlar",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle:
      "Paylaşılan Kaynakça - Paylaşılan Kaynakları Görüntüle ve İçe Aktar",
    metaDescription:
      "Birinin CitationEasy'den sizinle paylaştığı bir kaynakçayı açın. Biçimlendirilmiş kaynakları görüntüleyin, kopyalayın ya da tüm listeyi kendi kaynakçanıza aktarın — ücretsiz, hesap gerekmez ve veriler bağlantının kendisinde saklanır.",
    ogTitle: "Paylaşılan Kaynakça",
    ogDescription:
      "Paylaşılan bir kaynakçayı görüntüleyin ve içe aktarın. Kaynaklar bağlantının içinde taşınır — hiçbir şey sunucuda saklanmaz ve bağlantılar asla süresi dolmaz.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "Gezinme yolu",
    breadcrumbHome: "Ana sayfa",
    breadcrumbCurrent: "Paylaşılan kaynakça",
    heading: "Paylaşılan kaynakça",
    intro:
      "Biri bu kaynakları sizinle paylaştı. Kopyalayın ya da tüm listeyi tek tıkla kendi CitationEasy kaynakçanıza aktarın.",
    loading: "Paylaşılan kaynakça açılıyor…",
    copyAll: "Tümünü kopyala",
    copied: "Kopyalandı",
    copyFailed: "Kopyalama başarısız oldu",
    citationOne: "kaynak",
    citationMany: "kaynak",
    addAll: "Tümünü kaynakçama ekle",
    added: "{count} kaynakçanıza eklendi",
    skippedOne: "{count} yinelenen atlandı",
    skippedMany: "{count} yinelenen atlandı",
    openGenerator: "oluşturucuyu aç",
    emptyHeading: "Bu bağlantıda paylaşılan kaynakça yok",
    emptyBody:
      "Bu sayfa, CitationEasy'den paylaşılan kaynakçaları gösterir. Kendinizinkini paylaşmak için kaynakçanızı [kaynakça oluşturucuda](/) açın, **Dışa Aktar → Paylaşım bağlantısını kopyala** seçeneğini seçin ve bağlantıyı istediğiniz kişiye gönderin. Kaynaklar bağlantının kendisinin içinde taşınır — hiçbir şey sunucuda saklanmaz, bu yüzden bağlantılar sonsuza kadar çalışmaya devam eder ve verileriniz gizli kalır.",
    decodeError: "Bu paylaşım bağlantısı açılamadı.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "Kitap",
    bookLower: "kitap",
    bookChapter: "Kitap bölümü",
    bookChapterLower: "kitap bölümü",
    case: "Dava",
    caseLower: "dava",
    conferencePaper: "Konferans bildirisi",
    conferencePaperLower: "konferans bildirisi",
    courtCase: "Mahkeme davası",
    courtCaseLower: "mahkeme davası",
    federalStatute: "Federal kanun",
    federalStatuteLower: "federal kanun",
    governmentDocument: "Resmi belge",
    governmentDocumentLower: "resmi belge",
    governmentReport: "Resmi rapor",
    governmentReportLower: "resmi rapor",
    journalArticle: "Dergi makalesi",
    journalArticleLower: "dergi makalesi",
    lawReviewArticle: "Hukuk dergisi makalesi",
    lawReviewArticleLower: "hukuk dergisi makalesi",
    legislation: "Mevzuat",
    legislationLower: "mevzuat",
    newspaperArticle: "Gazete makalesi",
    newspaperArticleLower: "gazete makalesi",
    patent: "Patent",
    patentLower: "patent",
    podcast: "Podcast",
    podcastLower: "podcast",
    preprint: "Ön baskı",
    preprintLower: "ön baskı",
    standard: "Standart",
    standardLower: "standart",
    thesis: "Tez",
    thesisLower: "tez",
    website: "Web sitesi",
    websiteLower: "web sitesi",
    youtubeVideo: "YouTube videosu",
    youtubeVideoLower: "YouTube videosu",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "{style} sayfasına dön",
    backToGenerator: "Kaynakça oluşturucuya dön",
    ctaHeading: "{style} kaynaklarını otomatik oluşturun",
    ctaButton: "Şimdi {style} ile kaynak göster →",
    faqHeading: "Sık sorulan sorular",
    resourcesHeading: "Diğer kaynaklar",
    relatedHeading: "İlgili {style} rehberleri",
    resourceGenerator: "Ücretsiz kaynakça oluşturucu ({count} stil)",
    resourceTools: "Ücretsiz yazma araçları",
    resourceGuides: "Tüm kaynak gösterme rehberleri",
    resourceStyleGenerator: "{style} kaynakça oluşturucu",
    resourceExamples: "{style} kaynak gösterimi örnekleri",
    resourceFormat: "{style} biçim rehberi",
    resourceInText: "{style} metin içi atıf rehberi",
    resourceAnnotatedBib: "{style} açıklamalı kaynakça rehberi",
    resourceReferencePage: "{style} {list} rehberi",
    notFoundTitle: "Bulunamadı",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "{style} kaynak gösterimi örnekleri - Tüm kaynak türleri [2026]",
    metaDescription:
      "Kitaplar, dergi makaleleri, web siteleri ve daha fazlası için biçimlendirilmiş {style} ({edition}) kaynak gösterimi örneklerini görün. Kopyalamaya hazır {list} girdileri ve metin içi atıflar.",
    ogTitle: "{style} kaynak gösterimi örnekleri",
    ogDescription:
      "Her yaygın kaynak türü için kopyalamaya hazır {style} girdileri.",
    ogImageTitle: "{style} kaynak gösterimi örnekleri",
    ogKind: "{style} {edition}",
    keywordExamples: "{style} kaynak gösterimi örnekleri",
    keywordReference: "{style} kaynakça örnekleri",
    keywordInText: "{style} metin içi atıf örnekleri",
    keywordList: "{style} {listLower} örnekleri",
    keywordHowTo: "{style} ile nasıl kaynak gösterilir",
    breadcrumb: "{style} kaynak gösterimi örnekleri",
    heading: "{style} kaynak gösterimi örnekleri",
    lead: "{count} yaygın kaynak türü için doğru biçimlendirilmiş {style} ({edition}) kaynak gösterimi örneklerini görün. Her örnek, hem {listLower} girdisini hem de buna karşılık gelen metin içi atfı içerir.",
    entryLabel: "{list} girdisi:",
    inTextLabel: "Metin içi atıf:",
    ctaBody:
      "Elle biçimlendirmeyi atlayın. Bir DOI, URL veya ISBN'i CitationEasy'ye yapıştırın, saniyeler içinde eksiksiz biçimlendirilmiş bir {style} kaynak gösterimi elde edin.",
    faqLookQ: "{style} kaynak gösterimi nasıl görünür?",
    faqLookA:
      "{style} kaynak gösterimi, kaynağın tüm ayrıntılarını içeren bir {listLower} girdisi ve bir metin içi atıf içerir. Biçim, kaynak türüne göre değişir. Örneğin {style} ({edition}) stilinde bir kitap kaynak gösteriminde yazar, yıl, başlık ve yayıncı yer alır.",
    faqHowManyQ: "Kaç {style} kaynak gösterimi örneği mevcut?",
    faqHowManyA:
      "CitationEasy, {types} dahil olmak üzere {count} kaynak türü için {style} kaynak gösterimi örnekleri sunar. Her örnek, hem {listLower} girdisini hem de buna karşılık gelen metin içi atfı içerir.",
    faqCopyQ: "Bu {style} kaynak gösterimi örneklerini kopyalayabilir miyim?",
    faqCopyA:
      "Evet, bu sayfadaki {style} örnekleri her kaynak türü için tam biçimlendirmeyi gösterir. Bunları kendi kaynaklarınız için şablon olarak kullanabilirsiniz. Otomatik biçimlendirme için ücretsiz {style} kaynakça oluşturucumuzu kullanın.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle: "{style} biçim rehberi - Ödev biçimlendirme kuralları [2026]",
    metaDescription:
      "Kapsamlı {style} ({edition}) ödev biçimlendirme rehberi. Doğru yazı tipini, kenar boşluklarını, satır aralığını, başlık sayfasını, üstbilgileri ve {listLower} biçimlendirme kurallarını öğrenin.",
    ogTitle: "{style} ödev biçimi",
    ogDescription:
      "{style} ödevi için kenar boşlukları, yazı tipi, satır aralığı ve başlık sayfası.",
    ogImageTitle: "{style} ödev biçimi",
    ogImageSubtitle: "{margins} kenar boşlukları · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "{style} biçimi",
    keywordPaperFormat: "{style} ödev biçimi",
    keywordRules: "{style} biçimlendirme kuralları",
    keywordMargins: "{style} kenar boşlukları yazı tipi satır aralığı",
    keywordList: "{style} {listLower} biçimi",
    breadcrumb: "{style} biçim rehberi",
    heading: "{style} biçim rehberi",
    lead: "Belgenizin gereken standartları karşıladığından emin olmak için şu {style} ({edition}) ödev biçimlendirme kurallarını izleyin. Bu rehber; yazı tipini, kenar boşluklarını, satır aralığını, başlık sayfasını, üstbilgileri ve {listLower} biçimlendirmesini kapsar.",
    paperHeading: "Ödev biçimlendirmesi",
    paperIntro:
      "Aşağıda {style} ({edition}) stilinde yazılan ödevler için temel biçimlendirme gereksinimleri yer almaktadır.",
    labelFont: "Yazı tipi",
    labelFontSize: "Yazı tipi boyutu",
    labelMargins: "Kenar boşlukları",
    labelSpacing: "Satır aralığı",
    labelTitlePage: "Başlık sayfası",
    labelHeaders: "Üstbilgiler / sayfa numaraları",
    listHeading: "{list} biçimlendirmesi",
    listIntro:
      "{listLower} bölümünüzün {style} stilinde doğru biçimlendirilmiş sayılması için şu kurallara uymalıdır:",
    ctaBody:
      "Biçimlendirmeyi CitationEasy'ye bırakın. Bir DOI, URL veya ISBN yapıştırın, saniyeler içinde eksiksiz biçimlendirilmiş bir {style} kaynak gösterimi elde edin.",
    faqFontQ:
      "{style} biçimi için hangi yazı tipini ve boyutunu kullanmalıyım?",
    faqFontA:
      "{style} ({edition}), {font} gerektirir. Standart yazı tipi boyutu {fontSize}'tir.",
    faqMarginsQ: "{style} için kenar boşluğu gereksinimleri nelerdir?",
    faqMarginsA:
      "{style} ödevleri {margins} gerektirir. Bu, her sayfanın üst, alt, sol ve sağ kenar boşluklarına uygulanır.",
    faqTitlePageQ: "{style} bir başlık sayfası gerektirir mi?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "{style} metin içi atıf rehberi - Kurallar ve örnekler [2026]",
    metaDescription:
      "{style} ({edition}) metin içi atıflarını nasıl biçimlendireceğinizi öğrenin. Tek yazar, birden fazla yazar, doğrudan alıntılar, yazarsız kaynaklar ve tarihsiz kaynaklar için örnekli kurallar.",
    ogTitle: "{style} metin içi atıfları",
    ogDescription: "Örnekleriyle her {style} metin içi atıf biçimi.",
    ogImageTitle: "{style} metin içi atıfları",
    ogImageSubtitle:
      "Tek yazar {singleAuthor} · üç veya daha fazla {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "{style} metin içi atıf",
    keywordExamples: "{style} metin içi atıf örnekleri",
    keywordParenthetical: "{style} parantez içi atıf",
    keywordRules: "{style} atıf kuralları",
    keywordHowTo: "{style} metin içinde nasıl kaynak gösterilir",
    breadcrumb: "{style} metin içi atıfları",
    heading: "{style} metin içi atıfları",
    lead: "Bu kapsamlı rehberle {style} ({edition}) metin içi atıflarında ustalaşın. Tek ve birden fazla yazar, doğrudan alıntılar ve eksik bilgili kaynaklar dahil her senaryo için doğru biçimi öğrenin.",
    rulesHeading: "Metin içi atıf kuralları",
    rulesIntro:
      "Aşağıda, ödevinizi yazarken karşılaşacağınız her yaygın senaryo için {style} metin içi atıf kuralları yer almaktadır.",
    labelSingleAuthor: "Tek yazar",
    labelTwoAuthors: "İki yazar",
    labelThreeOrMore: "Üç veya daha fazla yazar",
    labelDirectQuote: "Doğrudan alıntı",
    labelNoAuthor: "Yazar yok",
    labelNoDate: "Tarih yok",
    examplesHeading: "Hızlı örnekler",
    examplesIntro:
      "İşte farklı kaynak türleri için gerçek dünyadan {style} metin içi atıf örnekleri:",
    ctaBody:
      "Metin içi atıf biçimlendirmesi konusunda endişelenmeyi bırakın. Bir DOI, URL veya ISBN'i CitationEasy'ye yapıştırın, hem {listLower} girdisini hem de metin içi atfı anında elde edin.",
    faqFormatQ: "{style} metin içi atfını nasıl biçimlendiririm?",
    faqFormatA:
      "{style} stilinde tek yazar için {singleAuthor} biçimini kullanın. İki yazar için {twoAuthors} kullanın. Üç veya daha fazla yazar için {threeOrMore} kullanın.",
    faqQuoteQ: "{style} stilinde doğrudan bir alıntıyı nasıl gösteririm?",
    faqQuoteA:
      "{style} ({edition}) stilinde doğrudan alıntılar için şu biçimi kullanın: {directQuote}.",
    faqMissingQ: "{style} stilinde yazar veya tarih yoksa ne yapmalıyım?",
    faqMissingA:
      "{style} stilinde yazar yoksa şunu kullanın: {noAuthor}. Tarih yoksa şunu kullanın: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "{style} {list} rehberi - Biçimlendirme kuralları [2026]",
    metaDescription:
      "{style} {listLower} ({edition}) nasıl biçimlendirilir öğrenin. {fullName} için adım adım biçimlendirme kuralları, örnekler ve kaçınılması gereken yaygın hatalar.",
    ogTitle: "{style} {listLower}",
    ogDescription: "{style} stilinde {list} nasıl oluşturulur.",
    ogImageTitle: "{style} {list}",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} {list} nasıl biçimlendirilir",
    heading: "{style} {list} nasıl biçimlendirilir",
    lead: "{listLower}, {style} ({edition}) stilinde biçimlendirilmiş herhangi bir akademik ödevin en önemli bölümlerinden biridir. Okuyuculara atıfta bulunduğunuz her kaynağın tüm ayrıntılarını sunarak kaynaklarınızı bulup doğrulamalarını sağlar. Doğru biçimlendirme akademik güvenilirlik için hayati önem taşır. Bu rehber, tam kuralları kapsar, gerçek örnekler gösterir ve öğrencilerin yaptığı en yaygın hataları vurgular.",
    rulesHeading: "Biçimlendirme kuralları",
    rulesIntro: "{style} {listLower} oluştururken şu kurallara uyun:",
    exampleHeading: "Örnek {list}",
    exampleIntro:
      "Farklı kaynak türleri için girdileri olan bir {style} {listLower} şöyle görünür:",
    mistakesHeading: "Kaçınılması gereken yaygın hatalar",
    mistakesIntro:
      "Öğrencilerin bir {style} {listLower} oluştururken yaptığı en sık beş biçimlendirme hatası şunlardır:",
    mistakeIndent:
      "**Eksik veya yanlış asılı girinti:** Her girdinin ilk satırı sola dayalı olmalı, sonraki tüm satırlar 1,27 cm içeriden başlamalıdır. Tab tuşuna basmak yerine kelime işlemcinizin paragraf ayarlarını kullanın.",
    mistakeOrder:
      '**Yanlış alfabetik sıralama veya düzen:** Girdiler {style} kurallarına göre düzenlenmelidir. Alfabetik sıralama yaparken İngilizcedeki "A," "An" ve "The" gibi tanımlıkları göz ardı edin. Numaralı stillerde girdileri metinde ilk göründükleri sırayla listeleyin.',
    mistakeSpacing:
      "**Tutarsız satır aralığı:** {listLower}'nin tamamında satır aralığını iki kez kontrol edin. Tek ve çift satır aralığını karıştırmak, gözden kolayca kaçan yaygın bir hatadır.",
    mistakeItalics:
      "**Yanlış italik kullanımı:** Kitap ve dergi gibi bağımsız eserlerin başlıklarını italik yapın, ancak makale veya bölüm başlıklarını italik yapmayın. Hangi öğelerin italik olması gerektiğini tam olarak öğrenmek için {style} yönergelerini kontrol edin.",
    mistakeLinks:
      "**Eksik veya bozuk DOI ve URL'ler:** Mevcut olduğunda her zaman tıklanabilir bir bağlantı olarak biçimlendirilmiş bir DOI ekleyin. Doğru kaynağa yönlendirdiğinden emin olmak için ödevinizi teslim etmeden önce her URL'yi test edin.",
    ctaHeading: "{list} kısmınızı otomatik oluşturun",
    ctaBody:
      "Elle biçimlendirmeyi atlayın. Bir DOI, URL veya ISBN'i CitationEasy'ye yapıştırın, {listLower} bölümünüz için hazır, saniyeler içinde eksiksiz biçimlendirilmiş bir {style} kaynak gösterimi elde edin.",
    faqWhatQ: "{style} {list} nedir?",
    faqWhatA:
      "{style} {list}, {fullName} ({edition}) yönergelerine göre biçimlendirilmiş, metninizde atıfta bulunduğunuz tüm kaynakların listelendiği, ödevinizin sonundaki bölümdür. Okuyucuların gönderme yaptığınız her kaynağı bulup doğrulamasını sağlar.",
    faqFormatQ: "Bir {style} {listLower} nasıl biçimlendiririm?",
    faqFormatA:
      'Yeni bir sayfada başlayın, "{list}" başlığını verin ve ödevinizde atıfta bulunduğunuz tüm kaynakları listeleyin. Asılı girintiler, satır aralığı, alfabetik veya numaralı sıralama düzeni ve italik kullanımı için {style} stiline özgü kurallara uyun.',
    faqDifferenceQ: "{listLower} ile bibliyografya arasındaki fark nedir?",
    faqDifferenceA:
      '{listLower}, yalnızca ödevinizde doğrudan atıfta bulunduğunuz kaynakları içerirken, bir bibliyografya başvurduğunuz ama atıfta bulunmadığınız kaynakları da içerebilir. {style} ({edition}) stilinde ödevin sonundaki listeye "{list}" denir.',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "{style} açıklamalı kaynakça rehberi ve örnekleri [2026]",
    metaDescription:
      "{style} ({edition}) stilinde açıklamalı kaynakça nasıl yazılır öğrenin. {fullName} açıklamalı kaynakçaları için biçimlendirme kuralları, örnek girdiler ve ipuçları içerir.",
    ogTitle: "{style} açıklamalı kaynakça",
    ogDescription:
      "{style} stilinde açıklamalı kaynakça nasıl biçimlendirilir.",
    ogImageTitle: "{style} açıklamalı kaynakça",
    ogKind: "{style} {edition}",
    breadcrumb: "{style} açıklamalı kaynakça",
    heading: "{style} açıklamalı kaynakça",
    lead: "Açıklamalı kaynakça, her biri kısa bir açıklayıcı veya değerlendirici paragraf içeren kaynak atıflarının listesidir. {style} biçiminde ({edition}), her girdi doğru biçimlendirilmiş bir kaynakla başlar ve ardından kaynağı özetleyen, değerlendiren veya yorumlayan bir açıklama gelir. Bu rehber, düzgün bir {style} açıklamalı kaynakçası oluşturmak için gereken kuralları, biçimlendirmeyi ve örnekleri anlatır.",
    whatHeading: "Açıklamalı kaynakça nedir?",
    whatBody:
      "Açıklamalı kaynakça, her atıftan sonra kısa bir paragraf ekleyerek standart bir {listLower}'in ötesine geçer. Bu açıklama okuyuculara kaynağın içeriği, kalitesi ve ilgisi hakkında fikir verir. Eğitmenler, öğrencilerin kaynaklarını eleştirel biçimde değerlendirmelerine ve her kaynağın araştırma konularına nasıl katkıda bulunduğunu göstermelerine yardımcı olmak için genellikle açıklamalı kaynakça ödevi verir.",
    whatTypes:
      "Üç yaygın açıklama türü vardır: kaynağı özetleyen **açıklayıcı** açıklamalar, çalışmanın kalitesini ve güvenilirliğini değerlendiren **değerlendirici** açıklamalar ve ikisini birden yapan **birleşik** açıklamalar. Ödev talimatlarınız hangi türün kullanılacağını belirtmelidir.",
    rulesHeading: "{style} açıklamalı kaynakça kuralları",
    rulesIntro:
      "{fullName} stilinde açıklamalı kaynakçayı biçimlendirirken şu kurallara uyun:",
    exampleHeading: "Örnek açıklamalı kaynakça girdisi",
    exampleIntro:
      "Aşağıda bir {sourceType} için örnek bir {style} açıklamalı kaynakça girdisi bulunmaktadır:",
    exampleAnnotation:
      "Bu kaynak, konuya ampirik kanıtlarla desteklenen sağlam argümanlar sunarak kapsamlı bir genel bakış sağlıyor. Yazar, ikna edici bir görüş oluşturmak için geniş bir birincil ve ikincil kaynak yelpazesinden yararlanıyor. Yöntem titiz ve bulgular açıkça sunulmuş; bu da çalışmayı konuyu anlamak için değerli bir kaynak haline getiriyor. Bu kaynak, özellikle araştırma projesinin kuramsal çerçevesini oluşturmak için yararlıdır ve kaynakçadaki diğer çalışmaları tamamlayan bakış açıları sunar.",
    tipsHeading: "{style} açıklamaları yazma ipuçları",
    tipSummarize:
      "Kaynağı iki ila üç cümleyle özetleyerek başlayın, ardından güçlü yönleri, sınırlılıkları ve ilgisi hakkındaki değerlendirmenizi ekleyin.",
    tipTone:
      "Açıklamalarınız boyunca üçüncü tekil şahıs ve akademik bir üslup kullanın. Eğitmeniniz istemedikçe gündelik dilden veya birinci şahıs yorumlarından kaçının.",
    tipLength:
      "Her açıklamayı 100 ila 200 kelime arasında tutun. Kısa ve öz olun, kaynağın en önemli yönlerine odaklanın.",
    tipRelevance:
      "Kaynağın genel araştırmanıza nasıl uyduğunu açıklayın. Hangi benzersiz bakış açısını veya kanıtı sunduğunu tanımlayın.",
    tipCitation:
      "Açıklamayı yazmadan önce her girdinin kaynak gösterme kısmının {fullName} biçimlendirme kurallarına tam olarak uyduğundan emin olun.",
    ctaHeading: "Açıklamalı kaynakçanızı otomatik oluşturun",
    ctaBody:
      "Doğru biçimlendirilmiş {style} kaynak gösterimleri oluşturmak için CitationEasy Açıklamalı Kaynakça Oluşturucusunu kullanın, ardından açıklamalarınızı ekleyin.",
    ctaButton: "Açıklamalı kaynakça oluşturucusunu aç →",
    faqWhatQ: "{style} stilinde açıklamalı kaynakça nedir?",
    faqWhatA:
      "{style} ({edition}) stilinde açıklamalı kaynakça, {fullName} stilinde biçimlendirilmiş, her biri kaynağı özetleyen, değerlendiren veya yorumlayan kısa bir paragrafla takip edilen atıfların listesidir. Okuyucuların her kaynağın ilgisini ve kalitesini anlamasına yardımcı olur.",
    faqLengthQ: "Açıklamalar ne kadar uzun olmalı?",
    faqLengthA:
      "Açıklamalar genellikle 100 ila 200 kelimedir. Bazı ödevler, beklenen analiz derinliğine bağlı olarak daha kısa veya daha uzun açıklamalar gerektirebilir. Belirli uzunluk gereksinimleri için her zaman eğitmeninizin yönergelerini kontrol edin.",
    faqIncludeQ: "Bir açıklama neler içermeli?",
    faqIncludeA:
      "Bir açıklama; kaynağın ana argümanının veya bulgularının kısa bir özetini, kaynağın güvenilirliği ve yararlılığının bir değerlendirmesini ve kaynağın araştırmanıza nasıl uyduğuna dair bir yorumu içermelidir. Bazı açıklamalar tamamen betimleyicidir, diğerleri eleştirel analiz içerir.",
  },

  guidePage: {
    byline: "Yazan: {author}",
    published: "Yayımlanma tarihi: {date}",
    updated: "Güncellenme tarihi: {date}",
    readingTime: "other:{count} dakikalık okuma",
    wordCount: "other:{count} kelime",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "Rehber kütüphanesi",
    browseByCategory: "Kategoriye göre göz at",
    recentlyUpdated: "Son güncellenenler",
    allGuides: "Tüm rehberler",
    guideCount: "other:{count} rehber",
    updatedOn: "{date} tarihinde güncellendi",
    minRead: "other:{count} dk okuma",
    onThisPage: "Bu sayfada",
    viewAllInCategory: "Tüm {category} rehberleri",
    moreInCategory: "{category} kategorisinde daha fazlası",
    aboutThisGuide: "Bu rehber hakkında",
    provenance:
      "{author} tarafından yazıldı. {published} tarihinde yayımlandı; son güncelleme {updated}.",
    categoryIntroSuffix:
      "Her rehber ücretsizdir, öğrenciler ve araştırmacılar için yazılmıştır ve en son ne zaman kontrol edildiğini görebilmeniz için tarihlendirilmiştir.",
    photoCredit: "Fotoğraf: {author}, {source} ({license})",
    imageAlt: "{category} rehberlerini betimleyen fotoğraf",
    imageSourceCommons: "Wikimedia Commons",
    apaStyleName: "APA Stili",
    apaStyleDescription:
      "Web sitelerini, dergi makalelerini, kitapları, videoları ve daha fazlasını APA 7. baskıya göre nasıl alıntılayacağınız; her biri için kaynakça ve metin içi örneklerle.",
    mlaStyleName: "MLA Stili",
    mlaStyleDescription:
      "Web sayfaları ve makalelerden şiirlere, oyunlara, filmlere ve ders materyallerine kadar tüm yaygın kaynakları MLA 9. baskıya göre alıntılama.",
    chicagoStyleName: "Chicago Stili",
    chicagoStyleDescription:
      "Kitaplar, makaleler, arşivler, resmi belgeler ve medya için not-kaynakça ve yazar-tarih alıntılarını kapsayan Chicago Manual of Style rehberleri.",
    styleComparisonsName: "Stil Karşılaştırmaları",
    styleComparisonsDescription:
      "APA, MLA, Chicago, Harvard, Vancouver, IEEE ve daha fazlasının yan yana karşılaştırması ve alanınızın hangi stili beklediğine dair öneriler.",
    researchMethodsName: "Araştırma Yöntemleri",
    researchMethodsDescription:
      "Araştırma makalesi planlama, literatür tarama, not alma, kaynak değerlendirme, intihalden kaçınma ve kaynakça oluşturma.",
    academicWritingName: "Akademik Yazım",
    academicWritingDescription:
      "Özet, giriş, sonuç, tez cümlesi, yöntem bölümü ve açık akademik metin yazımı için rehberler.",
    fieldSpecificName: "Alana Özel",
    fieldSpecificDescription:
      "Psikoloji, tarih ve edebiyattan tıp, mühendislik, hukuk ve hemşireliğe kadar tek tek disiplinler için alıntı rehberleri.",
    sourceEvaluationName: "Kaynak Değerlendirme",
    sourceEvaluationDescription:
      "Güvenilirliği değerlendirme, akademik ve popüler kaynakları ayırt etme, Google Akademik ve kütüphane veritabanlarını kullanma ve yanlılığı fark etme.",
    citationHelpName: "Alıntı Yardımı",
    citationHelpDescription:
      "Zor durumlara yanıtlar: eksik yazar veya tarih, çok yazarlı kaynaklar, PDF'ler, yapay zekâ araçları, hukuk davaları ve alıntıları içe veya dışa aktarma.",
  },

  common: {
    backToGuides: "← Rehberlere dön",
    free: "Ücretsiz",
    noSignup: "Üyelik gerekmez",
    backToHome: "Kaynakça oluşturucuya dön",
    inEnglish: "İngilizce",
    viewInEnglish: "İngilizce görüntüle",
    availableInEnglish: "Bu sayfa daha ayrıntılı olarak İngilizce mevcuttur.",
    otherLanguages: "Diğer diller",
    skipToContent: "İçeriğe geç",
    cookieNotice:
      "CitationEasy’yi ücretsiz tutmak için analiz ve reklam amaçlı çerezler kullanıyoruz.",
    privacyPolicy: "Gizlilik Politikası",
    accept: "Kabul et",
    decline: "Reddet",
    advertisement: "Reklam",
  },
  legalPage: {
    backLink: "← Oluşturucuya dön",
    effective: "Yürürlük tarihi:",
    updated: "Son güncelleme:",
  },
};

export default tr;
